// import React, { useEffect, useState, useMemo, useCallback } from 'react';
// import parties from '../data/party';
// import stockdata from '../data/stock';
// import sellstocks from '../data/sellstocks';
// import settingapi from '../data/setting';

// interface Party {
//   id: number;
//   name: string;
//   total_amount?: number | string;
// }

// type SellStockRecord = {
//   id: number;
//   party_id: number;
//   category: string;
//   stock_id: string;
//   stock_name: string;
//   sell_units: string;
//   sell_amount: string;
//   indirect_charges: string;
//   date: string;
//   catrgories?: string;
// };

// interface StockDBCategoryItem {
//   id: number | string;
//   investment_type: string;
//   category: string;
//   stock_name: string;
//   unit: string;
//   total_amount: string;
//   indirect_charges: string;
//   perUnitCharge: string;
// }

// type SellStockFormState = {
//   partyId: string;
//   category: string;
//   stockId: string | number;
//   stockName: string;
//   sellUnits: string;
//   sellAmount: string;
//   indirectCharges: string;
//   date: string;
// };

// const PRIMARY = '#17946B';
// const SECONDARY = '#FF9500';

// async function fetchSellStocks(): Promise<SellStockRecord[]> {
//   try {
//     const res = await sellstocks();
//     if (res && typeof res.json === 'function') {
//       if (!res.ok) return [];
//       const data = await res.json();
//       return Array.isArray(data) ? data : [];
//     } else if (Array.isArray(res)) {
//       return res;
//     }
//     return [];
//   } catch {
//     return [];
//   }
// }

// function getSellUnitsForStock(
//   sellStocks: SellStockRecord[],
//   partyId: string,
//   category: string,
//   stockName: string   // renamed for clarity
// ): number {
//   return sellStocks.reduce((sum, rec) => {
//     if (
//       String(rec.party_id) === String(partyId) &&
//       String(rec.category) === String(category) &&
//       String(rec.stock_id) === String(stockName)   // stock_id in DB is the name
//     ) {
//       return sum + parseFloat(rec.sell_units || '0');
//     }
//     return sum;
//   }, 0);
// }

// function getPartyStocksAdjusted(
//   stocksDbRows: any[],
//   sellStocks: SellStockRecord[],
//   partyId: string
// ) {
//   let result: { [category: string]: StockDBCategoryItem[] } = {};
//   for (const row of stocksDbRows) {
//     if (String(row.party_id) !== String(partyId)) continue;
//     let catsArr: StockDBCategoryItem[] = [];
//     if (typeof row.categories === 'string') {
//       try {
//         const parsed = JSON.parse(row.categories);
//         catsArr = Array.isArray(parsed) ? parsed : [];
//       } catch {
//         catsArr = [];
//       }
//     } else if (Array.isArray(row.categories)) {
//       catsArr = row.categories as StockDBCategoryItem[];
//     }
//     for (const item of catsArr) {
//       const soldUnits = getSellUnitsForStock(
//         sellStocks,
//         partyId,
//         item.category,
//         item.stock_name
//       );
//       let origUnit = parseFloat(item.unit || '0');
//       let remainingUnit = origUnit - soldUnits;
//       const adjustedItem = {
//         ...item,
//         unit: remainingUnit >= 0 ? String(remainingUnit) : '0',
//       };
//       if (!result[item.category]) result[item.category] = [];
//       result[item.category].push(adjustedItem);
//     }
//   }
//   return result;
// }

// // --- Helper to produce a unique key for stock options
// function getStockOptionKey(stock: StockDBCategoryItem) {
//   // Use id and stock_name together for uniqueness
//   return `${stock.category}__${stock.id}__${stock.stock_name}`;
// }

// const SellStocksPage = () => {
//   const [partiesList, setPartiesList] = useState<Party[]>([]);
//   const [sellStocks, setSellStocks] = useState<SellStockRecord[]>([]);
//   const [stocksDataDb, setStocksDataDb] = useState<any[]>([]);
//   const[totalamountspend, setTotalAmmountSpend] = useState<Number>();
//   const[farmName, setFarmName] = useState<string>();

//   const [sellStockForm, setSellStockForm] = useState<SellStockFormState>({
//     partyId: '',
//     category: '',
//     stockId: '',
//     stockName: '',
//     sellUnits: '',
//     sellAmount: '',
//     indirectCharges: '',
//     date: '',
//   });
//   const [autoAmount, setAutoAmount] = useState<number>(0);
//   const [loading, setLoading] = useState(false);
//   useEffect(() => {
//     async function fetchSettingsApi() {
//       try {
//         const res = await settingapi();
//         if (Array.isArray(res)) {
//           const farmSetting = res.find(
//             (item: any) => item.meta_key === "farm"
//           );
//           if (farmSetting && farmSetting.meta_value !== undefined) {
//             let farmObj = {};
//             try {
//               farmObj = typeof farmSetting.meta_value === "string"
//                 ? JSON.parse(farmSetting.meta_value)
//                 : farmSetting.meta_value;
//             } catch {}
//             if (
//               farmObj &&
//               typeof farmObj === "object" &&
//               farmObj !== null &&
//               "name" in farmObj &&
//               typeof (farmObj as { name?: unknown }).name === "string"
//             ) {
//               setFarmName((farmObj as { name: string }).name);
//             }
//           }
//         }
//       } catch {}
//     }
//     fetchSettingsApi();
//   }, []);
//   useEffect(() => {
//     async function loadSellStocks() {
//       const sellArr = await fetchSellStocks();
//       setSellStocks(sellArr);
//     }
//     loadSellStocks();
//   }, []);

//   useEffect(() => {
//     const urlParams = new URLSearchParams(window.location.search);
//     const partyId = urlParams.get('party') || '';
//     setSellStockForm((s) => ({ ...s, partyId }));
//   }, []);

//   useEffect(() => {
//     (async () => {
//       const pts = await parties();
//       setPartiesList(Array.isArray(pts) ? pts : []);

//       const db = await stockdata();
//       setStocksDataDb(Array.isArray(db) ? db : []);
//     })();
//   }, []);

//   const partyStocksByCat = useMemo(
//     () => getPartyStocksAdjusted(stocksDataDb, sellStocks, sellStockForm.partyId),
//     [stocksDataDb, sellStocks, sellStockForm.partyId]
//   );
//   const partyCategories = useMemo(
//     () => Object.keys(partyStocksByCat),
//     [partyStocksByCat]
//   );
//   const stocksInCurrentCategory = useMemo(
//     () =>
//       sellStockForm.category
//         ? (partyStocksByCat[sellStockForm.category] || []).filter(
//             s => !!(s.stock_name && s.stock_name.trim())
//           )
//         : [],
//     [sellStockForm.category, partyStocksByCat]
//   );

//   // Find selected stock object for current stockId or stockName
//   const selectedStockObj = useMemo(
//     () =>
//       stocksInCurrentCategory.find(
//         (s) =>
//           String(s.id) === String(sellStockForm.stockId) ||
//           String(s.stock_name) === String(sellStockForm.stockName)
//       ),
//     [sellStockForm.stockId, sellStockForm.stockName, stocksInCurrentCategory]
//   );

//   useEffect(() => {
//     const unitsNum = parseFloat(sellStockForm.sellUnits || '0');
//     if (!selectedStockObj || isNaN(unitsNum) || unitsNum <= 0) {
//       setAutoAmount(0);
//       return;
//     }
//     const totalAvailableUnits = parseFloat(selectedStockObj.unit);
//     const amount = parseFloat(selectedStockObj.total_amount);
//     let amt = totalAvailableUnits > 0 ? (amount / totalAvailableUnits) * unitsNum : 0;
//     setAutoAmount(amt);
//   }, [sellStockForm.sellUnits, selectedStockObj]);


//   const fetchUserRemainingBalance = useCallback(async (partyId: string) => {
//     if (!partyId) {
//       setTotalAmmountSpend(0);
//       return;
//     }

//     try {
//       const usermetaResponse = await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta`);
//       const usermetaList = await usermetaResponse.json();
      
//       // Find the record where meta_key is "remaining" and party_id matches
//       const foundMeta = usermetaList.find(
//         (meta: any) => meta.meta_key === "remaining" && String(meta.party_id) === String(partyId)
//       );

//       if (foundMeta) {
//         setTotalAmmountSpend(Number(foundMeta.meta_value));
//       } else {
//         // Fallback if no meta found: set to 0 or get original total_amount from partiesList
//         const party = partiesList.find(p => String(p.id) === String(partyId));
//         setTotalAmmountSpend(Number(party?.total_amount || 0));
//       }
//     } catch (err) {
//       console.error("Error fetching usermeta:", err);
//       setTotalAmmountSpend(0);
//     }
//   }, [partiesList]);
//   useEffect(() => {
//     const urlParams = new URLSearchParams(window.location.search);
//     const partyId = urlParams.get('party') || '';
//     fetchUserRemainingBalance(partyId);
// }, [fetchUserRemainingBalance]);
//   // --- UI EVENT HANDLERS ---
//   const handleFormChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
//     const { name, value } = e.target;

//     if (name === "sellUnits") {
//       if (selectedStockObj) {
//         const maxUnits = parseFloat(selectedStockObj.unit || "0");
//         if (value === "" || value === undefined) {
//           setSellStockForm(s => ({ ...s, sellUnits: "" }));
//           return;
//         }
//         const entered = parseFloat(value);
//         if (isNaN(entered) || entered < 0) {
//           return;
//         }
//         if (entered > maxUnits) {
//           setSellStockForm(s => ({ ...s, sellUnits: maxUnits.toString() }));
//           return;
//         }
//         setSellStockForm(s => ({ ...s, sellUnits: value }));
//         return;
//       }
//     }

//     if (name === "sellAmount") {
//       if (selectedStockObj) {
//         if (value === "" || value === undefined) {
//           setSellStockForm(s => ({ ...s, sellAmount: "" }));
//           return;
//         }
//         const entered = parseFloat(value);
//         if (isNaN(entered) || entered < 0) {
//           return;
//         }
//         setSellStockForm(s => ({ ...s, sellAmount: value }));
//         return;
//       }
//     }

//     let patch: Partial<SellStockFormState> = { [name]: value };
//     if (name === "partyId") {
//       patch.category = '';
//       patch.stockId = '';
//       patch.stockName = '';
//       patch.sellUnits = '';
//       patch.sellAmount = '';
//       patch.date = '';
//     }
//     if (name === "category") {
//       patch.stockId = '';
//       patch.stockName = '';
//       patch.sellUnits = '';
//       patch.sellAmount = '';
//     }
//     if (name === "stockId") {
//       // CHANGED: Now find the stock based on stock_name instead of id
//       const found = stocksInCurrentCategory.find(s => String(s.stock_name) === value);
//       patch.stockName = found ? found.stock_name : '';
//       patch.stockId = found ? found.stock_name : '';
//     }
//     setSellStockForm(s => ({ ...s, ...patch }));
//   };

//   const handleSellStockSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();
//     if (!sellStockForm.partyId) return alert('Select party');
//     if (!sellStockForm.category) return alert('Select category');
//     if (!sellStockForm.stockId) return alert('Select stock');
//     const sellUnitsNumber = parseFloat(sellStockForm.sellUnits || '0');
//     if (!sellUnitsNumber || isNaN(sellUnitsNumber) || sellUnitsNumber <= 0)
//       return alert('Please enter valid units to sell');
//     if (!selectedStockObj) return alert('Select valid stock');
//     if (sellUnitsNumber > parseFloat(selectedStockObj.unit || '0')) {
//       return alert(
//         `Not enough units available to sell! Available: ${selectedStockObj.unit}, Requested: ${sellUnitsNumber}`
//       );
//     }
//     if (!sellStockForm.date) return alert('Select date for sell');

//     // Get sell and indirect amounts as numbers (default 0 if empty)
//     const sellAmount = Number(sellStockForm.sellAmount) > 0 ? Number(sellStockForm.sellAmount) : (typeof autoAmount !== 'undefined' ? Number(autoAmount) : 0);
//     const indirectCharges = Number(sellStockForm.indirectCharges) || 0;

//     // Calculate actual amount to add on sale: (sales - indirect)
//     const netSale = sellAmount - indirectCharges;

//     const handleUserMetaUpdate = async () => {
//       try {
//         // Fetch usermeta for this party
//         const usermetaResponse = await fetch(
//           `${process.env.REACT_APP_API_URL}/auth/updateusermeta?party_id=${sellStockForm.partyId}`
//         );
//         const usermetaList = await usermetaResponse.json();
//         const foundMeta = Array.isArray(usermetaList)
//           ? usermetaList.find(
//               (meta: any) =>
//                 meta.meta_key === 'remaining' &&
//                 String(meta.party_id) === String(sellStockForm.partyId)
//             )
//           : undefined;

//         if (foundMeta) {
//           // Add sale: remaining = old_value + (sales - indirect_charges)
//           const oldVal = parseFloat(foundMeta.meta_value || '0');
//           const meta_value = (oldVal + netSale).toString();
//           await fetch(
//             `${process.env.REACT_APP_API_URL}/auth/updateusermeta/${foundMeta.id}`,
//             {
//               method: 'PUT',
//               headers: { 'Content-Type': 'application/json' },
//               body: JSON.stringify({
//                 meta_key: 'remaining',
//                 meta_value,
//                 party_id: sellStockForm.partyId,
//               }),
//             }
//           );
//         } else {
//           // If no remaining meta, use state's totalAmmountSpend as old, or fallback to 0
//           const oldVal = Number(totalamountspend) || 0;
//           const remaining = (oldVal + netSale).toString();
//           await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta`, {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({
//               meta_key: 'remaining',
//               meta_value: remaining,
//               party_id: sellStockForm.partyId,
//             }),
//           });
//         }
//       } catch (err) {
//         console.error('Usermeta API failed', err);
//       }
//     };

//     setLoading(true);
//     try {
//       const payload = {
//         party_id: sellStockForm.partyId,
//         category: sellStockForm.category,
//         stock_id: sellStockForm.stockId,
//         stock_name: sellStockForm.stockName,
//         sell_units: sellUnitsNumber,
//         sell_amount: sellAmount,
//         indirect_charges: sellStockForm.indirectCharges,
//         date: sellStockForm.date,
//       };

//       // Send main sellstocks request
//       const res = await fetch(
//         `${process.env.REACT_APP_API_URL}/auth/sellstocks`,
//         {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify(payload),
//         }
//       );
//       const result = await res.json();
//       if (!res.ok) throw new Error(result?.message || 'Failed to sell stock');

//       // ----- INVOICE API CALL -----
//       try {
//         const invoiceData = {
//           farm:farmName,
//           party: sellStockForm.partyId,
//           invoice_type: "sell",
//           date: sellStockForm.date,
//           // datainvoice is array of object (here, just the sell payload as an array)
//           datainvoice: JSON.stringify([{
//             stock_id: sellStockForm.stockId,
//             stock_name: sellStockForm.stockName,
//             category: sellStockForm.category,
//             sell_units: sellUnitsNumber,
//             sell_amount: sellAmount,
//             indirect_charges: sellStockForm.indirectCharges,
//             total_amount: sellAmount, // Instruction: total amount is sellAmount
//             date: sellStockForm.date
//           }])
//         };

//         await fetch(`${process.env.REACT_APP_API_URL}/auth/invoice`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(invoiceData)
//         });
//       } catch (err) {
//         // Only log, don't interrupt user flow
//         console.error("Error adding sell invoice:", err);
//       }
//       // ----- END INVOICE API CALL -----

//       // Prepare values for buysellrecord API
//       // totalpurchase = sell units * per unit price
//       let totalpurchase = 0;
//       let closingBLC = 0;
//       let totalsell = netSale;
//       let perUnitPrice = 0;
//       if (selectedStockObj) {
//         // Validate: try perUnitCharge if available, else fallback to total_amount/unit
//         perUnitPrice = Number(selectedStockObj.perUnitCharge);
//         if (!perUnitPrice || isNaN(perUnitPrice)) {
//           // fallback to total_amount / unit
//           const totalAmountVal = parseFloat(selectedStockObj.total_amount) || 0;
//           const totalUnitsVal = parseFloat(selectedStockObj.unit) + sellUnitsNumber; // restore sold units
//           perUnitPrice = totalUnitsVal > 0 ? (totalAmountVal / totalUnitsVal) : 0;
//         }
//       }
//       totalpurchase = sellUnitsNumber * perUnitPrice;
//       closingBLC = 0 - totalpurchase + totalsell;

//       // Send to buysellrecord endpoint
//       try {
//         const latestRes = await fetch(`${process.env.REACT_APP_API_URL}/auth/buysellrecord?_sort=date,id&_order=desc,desc`);
//         const latestList = await latestRes.json();
//         const latestEntry = Array.isArray(latestList) && latestList.length > 0 ? latestList[latestList.length - 1] : null;

//         if (latestEntry && latestEntry.totalpurchase !== undefined && latestEntry.id) {
//           const prevTotalSell = Number(latestEntry.totalsell) || 0;
//           const newTotalSell = prevTotalSell + totalsell;
//           const newClosingBLC = (Number(latestEntry.totalpurchase) || 0) - newTotalSell;

//           await fetch(`${process.env.REACT_APP_API_URL}/auth/buysellrecord`, {
//             method: 'PUT',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({
//               id: latestEntry.id,
//               date: sellStockForm.date,
//               totalpurchase: latestEntry.totalpurchase,
//               totalsell: newTotalSell,
//               closingBLC: newClosingBLC
//             })
//           });
//         } else {
//           // If not found or no totalpurchase, create new entry
//           await fetch(`${process.env.REACT_APP_API_URL}/auth/buysellrecord`, {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({
//               date: sellStockForm.date,
//               totalpurchase,
//               totalsell,
//               closingBLC,
//             }),
//           });
//         }
//       } catch (err) {
//         // Log, but don't block user
//         console.error('Failed to send buysellrecord', err);
//       }

//       // Update the UI state for totalAmmountSpend also using netSale
//       setTotalAmmountSpend(prev => (Number(prev) || 0) + netSale);

//       // Update user meta "remaining" record (async but doesn't block UX)
//       await handleUserMetaUpdate();

//       alert('Stock sell recorded successfully!');
//       setSellStockForm({
//         partyId: sellStockForm.partyId,
//         category: '',
//         stockId: '',
//         stockName: '',
//         sellUnits: '',
//         sellAmount: '',
//         indirectCharges: '',
//         date: '',
//       });
//       window.location.reload();
//     } catch (err: any) {
//       alert('Error: ' + (err?.message ?? 'Something went wrong'));
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ------------ UI ---------------
//   return (
//     <div className="w-full min-h-[80vh] flex flex-col items-center justify-center bg-gradient-to-br from-[#f6fcf8] to-[#fff8ef] py-10 transition-colors">
//       <div className="w-full max-w-2xl bg-white shadow-2xl rounded-3xl px-6 sm:px-12 py-10 border-4 border-[color:var(--primary)]/10 relative overflow-hidden duo-form-glow">
//         <div className="hidden absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[var(--primary)] to-[var(--secondary)] rounded-t-3xl animate-fadein" />

        
//         <h2 className="text-center text-4xl md:text-5xl font-extrabold mb-2 tracking-tighter duo-gradient-text drop-shadow-xl select-none">
//           Sell Stocks
//         </h2>
//         <p className="text-center text-gray-600 mb-7 italic bg-[color:var(--primary)]/10 rounded-xl px-3 py-2 text-base shadow border-l-4 border-[color:var(--secondary)]/30 font-medium">
//           <span className="inline-block px-2 py-1 bg-gradient-to-tr from-[color:var(--primary)]/10 to-[color:var(--secondary)]/10 rounded">Record a new stock sale transaction</span>
//           <br />
//           <span className="font-sans text-sm text-gray-400">Select party, then category, then stock.<br />(Party can be preselected via URL)</span>
//         </p>
//         <form
//           onSubmit={handleSellStockSubmit}
//           className="grid gap-8 grid-cols-1 md:grid-cols-2 animate-fadeInUp"
//           autoComplete="off"
//         >
//           {/* Party */}
//           <div className="col-span-1">
//             <label htmlFor="partyId" className="block mb-2 font-bold text-[color:var(--primary)] text-lg flex items-center gap-2 hover:text-[color:var(--secondary)] transition">
//               <span role="img" aria-label="party">👤</span> Party Name
//             </label>
//             <div className="relative">
//               <select
//                 name="partyId"
//                 id="partyId"
//                 value={sellStockForm.partyId}
//                 onChange={handleFormChange}
//                 className="w-full border-2 border-[color:var(--primary)] bg-[#f8fbf9] rounded-xl px-5 py-3 text-[color:var(--primary)] focus:ring-2 focus:ring-[color:var(--primary)]/60 font-semibold  transition-all"
//                 required
//                 style={{ color: 'var(--primary)' }}
//               >
//                 <option value="">Choose Party</option>
//                 {partiesList.map(p => (
//                   <option key={String(p.id)} value={String(p.id)}>{p.name}</option>
//                 ))}
//               </select>
//               <span className="absolute right-4 top-1/2 -translate-y-1/2 text-[color:var(--primary)] pointer-events-none hidden">
//                 <svg width={20} height={20} fill="none" viewBox="0 0 20 20"><path d="m5 8 5 5 5-5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/></svg>
//               </span>
//             </div>
//           </div>
//           {/* Category */}
//           <div className="col-span-1">
//             <label htmlFor="category" className="block mb-2 font-bold text-[color:var(--secondary)] text-lg flex items-center gap-2 hover:text-[color:var(--primary)] transition">
//               <span role="img" aria-label="category">📂</span> Category
//             </label>
//             <div className="relative">
//               <select
//                 name="category"
//                 id="category"
//                 value={sellStockForm.category}
//                 onChange={handleFormChange}
//                 required
//                 disabled={!sellStockForm.partyId}
//                 className={`w-full border-2 bg-[#fffcf7] border-[color:var(--secondary)] rounded-xl px-5 py-3 text-[color:var(--secondary)] font-semibold  focus:ring-2 focus:ring-[color:var(--secondary)]/50 transition-all ${!sellStockForm.partyId ? 'bg-gray-50 opacity-60 cursor-not-allowed' : ''}`}
//                 style={{ color: 'var(--secondary)' }}
//               >
//                 <option value="">Select Category</option>
//                 {partyCategories.map(cat => (
//                   <option key={String(cat)} value={cat}>{cat}</option>
//                 ))}
//               </select>
//               <span className="absolute right-4 top-1/2 -translate-y-1/2 text-[color:var(--secondary)] pointer-events-none hidden">
//                 <svg width={20} height={20} fill="none" viewBox="0 0 20 20"><path d="m5 8 5 5 5-5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/></svg>
//               </span>
//             </div>
//           </div>
//           {/* Stock Name */}
//           <div className="col-span-1 md:col-span-2">
//             <label htmlFor="stockId" className="block mb-2 font-bold text-[color:var(--primary)] text-lg flex items-center gap-2 hover:text-[color:var(--secondary)] transition">
//               <span role="img" aria-label="stock">🏷️</span> Stock Name
//             </label>
//             <div className="relative">
//               <select
//                 name="stockId"
//                 id="stockId"
//                 value={sellStockForm.stockId}
//                 onChange={handleFormChange}
//                 required
//                 disabled={!sellStockForm.category}
//                 className={`w-full border-2 border-[color:var(--primary)] bg-[#f6fbf8] rounded-xl px-5 py-3 text-[color:var(--primary)] font-semibold  focus:ring-2 focus:ring-[color:var(--primary)]/50 transition-all ${!sellStockForm.category ? 'bg-gray-50 opacity-60 cursor-not-allowed' : ''}`}
//                 style={{ color: 'var(--primary)' }}
//               >
//                 <option value="">Select Stock</option>
//                 {stocksInCurrentCategory.map(stock =>
//                   !!(stock.stock_name && stock.stock_name.trim()) && (
//                     <option key={getStockOptionKey(stock)} value={stock.stock_name}>{stock.stock_name}</option>
//                   )
//                 )}
//               </select>
//               <span className="absolute right-4 top-1/2 -translate-y-1/2 text-[color:var(--primary)] pointer-events-none hidden">
//                 <svg width={20} height={20} fill="none" viewBox="0 0 20 20"><path d="m5 8 5 5 5-5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/></svg>
//               </span>
//             </div>
//             {sellStockForm.category && stocksInCurrentCategory.length === 0 && (
//               <p className="text-xs text-center text-red-500 mt-2 font-mono italic">No stocks available under this category.</p>
//             )}
//           </div>
//           {/* Units To Sell */}
//           <div className="col-span-1">
//             <label htmlFor="sellUnits" className="block mb-2 font-bold text-[color:var(--primary)] text-lg flex items-center gap-2 hover:text-[color:var(--secondary)] transition">
//               <span role="img" aria-label="units">🔢</span> Units To Sell
//               {selectedStockObj && (
//                 <span className='text-xs ml-2 text-gray-400 font-normal'>(Available: <b className="text-[color:var(--secondary)]">{selectedStockObj.unit}</b>)</span>
//               )}
//             </label>
//             <div className="relative">
//               <input
//                 type="number"
//                 name="sellUnits"
//                 id="sellUnits"
//                 value={sellStockForm.sellUnits}
//                 required
//                 disabled={!sellStockForm.stockId}
//                 min={0}
//                 max={selectedStockObj ? selectedStockObj.unit : undefined}
//                 onChange={handleFormChange}
//                 className="w-full border-2 border-[color:var(--primary)] bg-[#f6fbf8] rounded-xl px-5 py-3 text-[color:var(--primary)] font-medium  focus:ring-2 focus:ring-[color:var(--primary)]/40 placeholder-gray-300 transition-all"
//                 placeholder='How many units to sell'
//                 style={{ color: 'var(--primary)' }}
//                 step="any" // allow decimals
//                 inputMode="decimal"
//                 pattern="[0-9.]*"
//               />
        
//             </div>
//             {sellStockForm.sellUnits && selectedStockObj && parseFloat(sellStockForm.sellUnits) > parseFloat(selectedStockObj.unit) ? (
//               <span className="text-xs text-red-600 font-semibold px-2 py-1 inline-block bg-[#ffedf1] rounded mt-1">Not enough units available!</span>
//             ) : null}
//           </div>
//           {/* Optional: Selling Amount (editable or auto, shows calculation) */}
//           <div className="col-span-1">
//             <label htmlFor="sellAmount" className="block mb-2 font-bold text-[color:var(--secondary)] text-lg flex items-center gap-2 hover:text-[color:var(--primary)] transition">
//               <span role="img" aria-label="amount">💰</span> Sell Amount
//               <span className='text-xs bg-[#fff8ef] text-[color:var(--primary)] px-2 py-1 rounded font-mono ml-2'>
//                 (Auto: {(autoAmount || 0).toFixed(2)} {sellStockForm.sellUnits ? 'calculated' : ''})
//               </span>
//             </label>
//             <div className="relative">
//               <input
//                 type="number"
//                 name="sellAmount"
//                 id="sellAmount"
//                 placeholder={`Auto: ${(autoAmount || 0).toFixed(2)}`}
//                 value={sellStockForm.sellAmount}
//                 min={0}
//                 step="any"
//                 onChange={handleFormChange}
//                 required
//                 disabled={!sellStockForm.stockId}
//                 className="w-full border-2 border-[color:var(--secondary)] bg-[#fff8ef] rounded-xl px-5 py-3 text-[color:var(--secondary)] font-medium   focus:ring-2 focus:ring-[color:var(--secondary)]/50 transition-all placeholder-gray-400"
//                 style={{ color: 'var(--secondary)' }}
//                 inputMode="decimal"
//                 pattern="[0-9]*"
//               />
//             </div>
//             <span className="block text-xs text-gray-400 mt-1 font-mono ml-2">
//               Leave blank for auto-calculated. You can adjust if desired.
//             </span>
//           </div>
//           {/* Indirect Charges */}
//           <div className="col-span-1">
//             <label htmlFor="indirectCharges" className="block mb-2 font-bold text-[color:var(--primary)] text-lg flex items-center gap-2 hover:text-[color:var(--secondary)] transition">
//               <span role="img" aria-label="fees">💸</span> Indirect Charges
//             </label>
//             <div className="relative">
//               <input
//                 type="number"
//                 name="indirectCharges"
//                 id="indirectCharges"
//                 placeholder="Enter indirect charges (if any)"
//                 value={sellStockForm.indirectCharges}
//                 min={0}
//                 step="any"
//                 onChange={handleFormChange}
//                 disabled={!sellStockForm.stockId}
//                 className="w-full border-2 border-[color:var(--primary)] bg-[#f6fbf8] rounded-xl px-5 py-3 text-[color:var(--primary)] font-normal   focus:ring-2 focus:ring-[color:var(--primary)]/60 placeholder-gray-300 transition-all  "
//                 style={{ color: 'var(--primary)' }}
//               />
//             </div>
//           </div>
//           {/* Date */}
//           <div className="col-span-1">
//             <label htmlFor="date" className="block mb-2 font-bold text-[color:var(--secondary)] text-lg flex items-center gap-2 hover:text-[color:var(--primary)] transition">
//               <span role="img" aria-label="date">📅</span> Date
//             </label>
//             <div className="relative">
//               <input
//                 type="date"
//                 name="date"
//                 id="date"
//                 value={sellStockForm.date}
//                 onChange={handleFormChange}
//                 required
//                 className="w-full border-2 border-[color:var(--secondary)] bg-[#fff8ef] rounded-xl px-5 py-3 text-[color:var(--secondary)] font-medium   focus:ring-2 focus:ring-[color:var(--secondary)]/40 transition-all"
//                 disabled={!sellStockForm.stockId}
//                 style={{ color: 'var(--secondary)' }}
//               />
//             </div>
//           </div>
//           {/* Button */}
//           <div className="col-span-1 md:col-span-2 flex flex-col md:flex-row-reverse justify-between items-center gap-3 pt-2">
//             <button
//               type="submit"
//               disabled={loading}
//               className={`px-10 py-3 rounded-full bg-gradient-to-r from-[color:var(--primary)] to-[color:var(--secondary)] text-white font-extrabold text-2xl transform hover:scale-105 active:scale-100 transition-all  focus:outline-none focus:ring-4 focus:ring-[color:var(--primary)]/50 disabled:opacity-60 flex items-center gap-2 border-b-4 border-[color:var(--secondary)]/50`}
//               style={{ boxShadow: "0 8px 48px 3px #94efd990, 0 3px 15px -2px #f8bb498f" }}
//             >
//               {loading ? (
//                 <>
//                   <svg className="animate-spin mr-2 h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                     <circle
//                       className="opacity-25"
//                       cx="12"
//                       cy="12"
//                       r="10"
//                       stroke="currentColor"
//                       strokeWidth="4"
//                     />
//                     <path
//                       className="opacity-75"
//                       fill="currentColor"
//                       d="M4 12a8 8 0 018-8v8z"
//                     />
//                   </svg>
//                   Selling...
//                 </>
//               ) : (
//                 <>
//                   <span role="img" aria-label="sell">💸</span> Sell Stock
//                 </>
//               )}
//             </button>
//             <span className=" text-xs text-gray-300 italic hidden md:inline-block !hidden">Powered by <span className="font-bold text-[color:var(--primary)]">StockManager</span></span>
//           </div>
//         </form>
//       </div>
//       <style>{`
//         :root {
//           --primary: ${PRIMARY};
//           --secondary: ${SECONDARY};
//         }
//         .duo-gradient-text {
//           background: linear-gradient(90deg, var(--primary), var(--secondary) 100%);
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//           background-clip: text;
//         }
//         @media (max-width: 600px){
//           .duo-form-glow:before, .duo-form-glow:after{display:none;}
//         }
//         .animate-fadein{
//           animation: fadeInLeft 0.7s cubic-bezier(.29,.31,.41,1.41);
//         }
//         @keyframes fadeInLeft{
//           0%{ opacity:0; transform:translateX(-100%);}
//           80%{ opacity:0.2;}
//           100%{ opacity:1; transform: translateX(0);}
//         }
//         .animate-fadeInUp {
//           animation: fadeInUp 1.0s cubic-bezier(.38,.33,.52,1.42);
//         }
//         @keyframes fadeInUp {
//           0% {opacity: 0; transform: translateY(40px);}
//           100% {opacity: 1; transform: translateY(0);}
//         }
//       `}</style>
//     </div>
//   );
// };

// export default SellStocksPage;
// import React, { useEffect, useState, useMemo, useCallback } from 'react';
// import parties from '../data/party';
// import stockdata from '../data/stock';
// import sellstocks from '../data/sellstocks';
// import settingapi from '../data/setting';
// import OcrUploadModal from './OcrUploadModal';

// interface Party {
//   id: number;
//   name: string;
//   total_amount?: number | string;
// }

// type SellStockRecord = {
//   id: number;
//   party_id: number;
//   category: string;
//   stock_id: string;
//   stock_name: string;
//   sell_units: string;
//   sell_amount: string;
//   indirect_charges: string;
//   date: string;
//   catrgories?: string;
// };

// interface StockDBCategoryItem {
//   id: number | string;
//   investment_type: string;
//   category: string;
//   stock_name: string;
//   unit: string;
//   total_amount: string;
//   indirect_charges: string;
//   perUnitCharge: string;
// }

// // Deduplicated stock with merged units/amounts across DB rows
// interface MergedStockItem {
//   stock_name: string;
//   category: string;
//   unit: string;          // sum of remaining units across all rows
//   total_amount: string;  // sum of total_amount across all rows
//   indirect_charges: string;
//   perUnitCharge: string; // weighted average
//   investment_type: string;
//   // Keep ids of all source rows for reference
//   sourceIds: (number | string)[];
// }

// type SellStockFormState = {
//   partyId: string;
//   category: string;
//   stockId: string | number;
//   stockName: string;
//   sellUnits: string;
//   sellAmount: string;
//   indirectCharges: string;
//   date: string;
// };

// const PRIMARY = '#17946B';
// const SECONDARY = '#FF9500';

// async function fetchSellStocks(): Promise<SellStockRecord[]> {
//   try {
//     const res = await sellstocks();
//     if (res && typeof res.json === 'function') {
//       if (!res.ok) return [];
//       const data = await res.json();
//       return Array.isArray(data) ? data : [];
//     } else if (Array.isArray(res)) {
//       return res;
//     }
//     return [];
//   } catch {
//     return [];
//   }
// }

// function getSellUnitsForStock(
//   sellStocks: SellStockRecord[],
//   partyId: string,
//   category: string,
//   stockName: string
// ): number {
//   return sellStocks.reduce((sum, rec) => {
//     if (
//       String(rec.party_id) === String(partyId) &&
//       String(rec.category) === String(category) &&
//       String(rec.stock_id) === String(stockName)
//     ) {
//       return sum + parseFloat(rec.sell_units || '0');
//     }
//     return sum;
//   }, 0);
// }

// function getPartyStocksAdjusted(
//   stocksDbRows: any[],
//   sellStocks: SellStockRecord[],
//   partyId: string
// ) {
//   let result: { [category: string]: StockDBCategoryItem[] } = {};
//   for (const row of stocksDbRows) {
//     if (String(row.party_id) !== String(partyId)) continue;
//     let catsArr: StockDBCategoryItem[] = [];
//     if (typeof row.categories === 'string') {
//       try {
//         const parsed = JSON.parse(row.categories);
//         catsArr = Array.isArray(parsed) ? parsed : [];
//       } catch {
//         catsArr = [];
//       }
//     } else if (Array.isArray(row.categories)) {
//       catsArr = row.categories as StockDBCategoryItem[];
//     }
//     for (const item of catsArr) {
//       const soldUnits = getSellUnitsForStock(
//         sellStocks,
//         partyId,
//         item.category,
//         item.stock_name
//       );
//       let origUnit = parseFloat(item.unit || '0');
//       let remainingUnit = origUnit - soldUnits;
//       const adjustedItem = {
//         ...item,
//         unit: remainingUnit >= 0 ? String(remainingUnit) : '0',
//       };
//       if (!result[item.category]) result[item.category] = [];
//       result[item.category].push(adjustedItem);
//     }
//   }
//   return result;
// }

// /**
//  * Merges duplicate stock entries (same stock_name + category) across multiple
//  * DB rows into a single item, summing units and amounts, computing weighted avg
//  * perUnitCharge, and dropping entries with 0 remaining units.
//  */
// function mergeStocksByName(items: StockDBCategoryItem[]): MergedStockItem[] {
//   const map = new Map<string, MergedStockItem>();

//   for (const item of items) {
//     const key = `${item.category}__${item.stock_name}`;
//     const unit = parseFloat(item.unit || '0');
//     const totalAmount = parseFloat(item.total_amount || '0');
//     const indirectCharges = parseFloat(item.indirect_charges || '0');

//     if (map.has(key)) {
//       const existing = map.get(key)!;
//       const newUnit = parseFloat(existing.unit) + unit;
//       const newTotal = parseFloat(existing.total_amount) + totalAmount;
//       const newIndirect = parseFloat(existing.indirect_charges) + indirectCharges;
//       const newPerUnit = newUnit > 0 ? ((newTotal + newIndirect) / newUnit).toFixed(2) : '0.00';

//       map.set(key, {
//         ...existing,
//         unit: String(newUnit),
//         total_amount: String(newTotal),
//         indirect_charges: String(newIndirect),
//         perUnitCharge: newPerUnit,
//         sourceIds: [...existing.sourceIds, item.id],
//       });
//     } else {
//       map.set(key, {
//         stock_name: item.stock_name,
//         category: item.category,
//         unit: String(unit),
//         total_amount: String(totalAmount),
//         indirect_charges: String(indirectCharges),
//         perUnitCharge: item.perUnitCharge || (unit > 0 ? ((totalAmount + indirectCharges) / unit).toFixed(2) : '0.00'),
//         investment_type: item.investment_type,
//         sourceIds: [item.id],
//       });
//     }
//   }

//   // Filter out stocks with 0 remaining units
//   return Array.from(map.values()).filter(
//     s => !!(s.stock_name && s.stock_name.trim()) && parseFloat(s.unit) > 0
//   );
// }

// function safeNumber(v: any): number {
//   const n = parseFloat(String(v));
//   return isNaN(n) ? 0 : n;
// }

// const SellStocksPage = () => {
//   const [partiesList, setPartiesList] = useState<Party[]>([]);
//   const [sellStocks, setSellStocks] = useState<SellStockRecord[]>([]);
//   const [stocksDataDb, setStocksDataDb] = useState<any[]>([]);
//   const [totalamountspend, setTotalAmmountSpend] = useState<Number>();
//   const [showOcrModal, setShowOcrModal] = useState(false);
//   const [farmName, setFarmName] = useState<string>();

//   const [sellStockForm, setSellStockForm] = useState<SellStockFormState>({
//     partyId: '',
//     category: '',
//     stockId: '',
//     stockName: '',
//     sellUnits: '',
//     sellAmount: '',
//     indirectCharges: '',
//     date: '',
//   });
//   const [autoAmount, setAutoAmount] = useState<number>(0);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     async function fetchSettingsApi() {
//       try {
//         const res = await settingapi();
//         if (Array.isArray(res)) {
//           const farmSetting = res.find((item: any) => item.meta_key === 'farm');
//           if (farmSetting && farmSetting.meta_value !== undefined) {
//             let farmObj = {};
//             try {
//               farmObj =
//                 typeof farmSetting.meta_value === 'string'
//                   ? JSON.parse(farmSetting.meta_value)
//                   : farmSetting.meta_value;
//             } catch {}
//             if (
//               farmObj &&
//               typeof farmObj === 'object' &&
//               farmObj !== null &&
//               'name' in farmObj &&
//               typeof (farmObj as { name?: unknown }).name === 'string'
//             ) {
//               setFarmName((farmObj as { name: string }).name);
//             }
//           }
//         }
//       } catch {}
//     }
//     fetchSettingsApi();
//   }, []);

//   useEffect(() => {
//     async function loadSellStocks() {
//       const sellArr = await fetchSellStocks();
//       setSellStocks(sellArr);
//     }
//     loadSellStocks();
//   }, []);

//   useEffect(() => {
//     const urlParams = new URLSearchParams(window.location.search);
//     const partyId = urlParams.get('party') || '';
//     setSellStockForm((s) => ({ ...s, partyId }));
//   }, []);

//   useEffect(() => {
//     (async () => {
//       const pts = await parties();
//       setPartiesList(Array.isArray(pts) ? pts : []);
//       const db = await stockdata();
//       setStocksDataDb(Array.isArray(db) ? db : []);
//     })();
//   }, []);

//   async function fetchParties() {
//     const pts = await parties();
//     setPartiesList(Array.isArray(pts) ? pts : []);
//   }

//   // Raw (unadjusted) stocks by category for the selected party
//   const partyStocksByCat = useMemo(
//     () => getPartyStocksAdjusted(stocksDataDb, sellStocks, sellStockForm.partyId),
//     [stocksDataDb, sellStocks, sellStockForm.partyId]
//   );

//   const partyCategories = useMemo(() => Object.keys(partyStocksByCat), [partyStocksByCat]);

//   // Raw items for the selected category (may have duplicates)
//   const rawStocksInCategory = useMemo(
//     () =>
//       sellStockForm.category ? partyStocksByCat[sellStockForm.category] || [] : [],
//     [sellStockForm.category, partyStocksByCat]
//   );

//   // Deduplicated, merged stocks — one entry per unique stock_name with 0-unit entries removed
//   const stocksInCurrentCategory = useMemo(
//     () => mergeStocksByName(rawStocksInCategory),
//     [rawStocksInCategory]
//   );

//   // The selected merged stock object
//   const selectedStockObj = useMemo(
//     () =>
//       stocksInCurrentCategory.find(
//         (s) => String(s.stock_name) === String(sellStockForm.stockName)
//       ),
//     [sellStockForm.stockName, stocksInCurrentCategory]
//   );

//   useEffect(() => {
//     const unitsNum = parseFloat(sellStockForm.sellUnits || '0');
//     if (!selectedStockObj || isNaN(unitsNum) || unitsNum <= 0) {
//       setAutoAmount(0);
//       return;
//     }
//     const totalAvailableUnits = parseFloat(selectedStockObj.unit);
//     const amount = parseFloat(selectedStockObj.total_amount);
//     const amt = totalAvailableUnits > 0 ? (amount / totalAvailableUnits) * unitsNum : 0;
//     setAutoAmount(amt);
//   }, [sellStockForm.sellUnits, selectedStockObj]);

//   const fetchUserRemainingBalance = useCallback(
//     async (partyId: string) => {
//       if (!partyId) {
//         setTotalAmmountSpend(0);
//         return;
//       }
//       try {
//         const usermetaResponse = await fetch(
//           `${process.env.REACT_APP_API_URL}/auth/updateusermeta`
//         );
//         const usermetaList = await usermetaResponse.json();
//         const foundMeta = usermetaList.find(
//           (meta: any) =>
//             meta.meta_key === 'remaining' && String(meta.party_id) === String(partyId)
//         );
//         if (foundMeta) {
//           setTotalAmmountSpend(Number(foundMeta.meta_value));
//         } else {
//           const party = partiesList.find((p) => String(p.id) === String(partyId));
//           setTotalAmmountSpend(Number(party?.total_amount || 0));
//         }
//       } catch (err) {
//         console.error('Error fetching usermeta:', err);
//         setTotalAmmountSpend(0);
//       }
//     },
//     [partiesList]
//   );

//   useEffect(() => {
//     const urlParams = new URLSearchParams(window.location.search);
//     const partyId = urlParams.get('party') || '';
//     fetchUserRemainingBalance(partyId);
//   }, [fetchUserRemainingBalance]);

//   // --- UI EVENT HANDLERS ---
//   const handleFormChange = (
//     e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
//   ) => {
//     const { name, value } = e.target;

//     if (name === 'sellUnits') {
//       if (selectedStockObj) {
//         const maxUnits = parseFloat(selectedStockObj.unit || '0');
//         if (value === '' || value === undefined) {
//           setSellStockForm((s) => ({ ...s, sellUnits: '' }));
//           return;
//         }
//         const entered = parseFloat(value);
//         if (isNaN(entered) || entered < 0) return;
//         if (entered > maxUnits) {
//           setSellStockForm((s) => ({ ...s, sellUnits: maxUnits.toString() }));
//           return;
//         }
//         setSellStockForm((s) => ({ ...s, sellUnits: value }));
//         return;
//       }
//     }

//     if (name === 'sellAmount') {
//       if (selectedStockObj) {
//         if (value === '' || value === undefined) {
//           setSellStockForm((s) => ({ ...s, sellAmount: '' }));
//           return;
//         }
//         const entered = parseFloat(value);
//         if (isNaN(entered) || entered < 0) return;
//         setSellStockForm((s) => ({ ...s, sellAmount: value }));
//         return;
//       }
//     }

//     let patch: Partial<SellStockFormState> = { [name]: value };
//     if (name === 'partyId') {
//       patch.category = '';
//       patch.stockId = '';
//       patch.stockName = '';
//       patch.sellUnits = '';
//       patch.sellAmount = '';
//       patch.date = '';
//     }
//     if (name === 'category') {
//       patch.stockId = '';
//       patch.stockName = '';
//       patch.sellUnits = '';
//       patch.sellAmount = '';
//     }
//     if (name === 'stockId') {
//       // value is stock_name (used as the option value)
//       const found = stocksInCurrentCategory.find(
//         (s) => String(s.stock_name) === value
//       );
//       patch.stockName = found ? found.stock_name : '';
//       patch.stockId = found ? found.stock_name : '';
//     }
//     setSellStockForm((s) => ({ ...s, ...patch }));
//   };

//   // ─── OCR submit — mirrors handleSellStockSubmit for sell flow ───────────────
//   // NOTE: OcrUploadModal batches are purchase records (buy flow).
//   // This handler processes each OCR batch row as a SELL transaction,
//   // matching the same invoice / buysellrecord / usermeta pattern used in
//   // handleSellStockSubmit.
//   const handleOcrSubmit = async ({
//     partyId,
//     category,
//     batches,
//   }: {
//     partyId: string;
//     category: string;
//     batches: { date: string; rows: any[] }[];
//   }): Promise<void> => {
//     if (!partyId) { alert('Please select a party'); return; }
//     if (!category) { alert('Please select a category'); return; }

//     for (const batch of batches) {
//       if (!batch.date) continue;
//       const validRows = batch.rows.filter((r: any) => r.stock_name?.trim());
//       if (!validRows.length) continue;

//       for (const row of validRows) {
//         // Resolve the merged stock to get accurate available units & per-unit price
//         const mergedStock = stocksInCurrentCategory.find(
//           (s) => s.stock_name === row.stock_name && s.category === category
//         );

//         const sellUnitsNumber = safeNumber(row.sell_units ?? row.unit);
//         if (!sellUnitsNumber || sellUnitsNumber <= 0) continue;

//         if (mergedStock) {
//           const available = parseFloat(mergedStock.unit);
//           if (sellUnitsNumber > available) {
//             alert(
//               `Not enough units for "${row.stock_name}". ` +
//               `Available: ${available}, Requested: ${sellUnitsNumber}`
//             );
//             continue;
//           }
//         }

//         // Determine sell amount — prefer explicit value, else auto-calculate
//         let sellAmount = safeNumber(row.sell_amount ?? row.total_amount);
//         if (!sellAmount && mergedStock) {
//           const availableUnits = parseFloat(mergedStock.unit);
//           const totalAmt = parseFloat(mergedStock.total_amount);
//           sellAmount =
//             availableUnits > 0 ? (totalAmt / availableUnits) * sellUnitsNumber : 0;
//         }

//         const indirectCharges = safeNumber(row.indirect_charges ?? 0);
//         const netSale = sellAmount - indirectCharges;

//         // 1) Main sellstocks record
//         try {
//           const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/sellstocks`, {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({
//               party_id: partyId,
//               category,
//               stock_id: row.stock_name,    // stock_id stored as name, same as handleSellStockSubmit
//               stock_name: row.stock_name,
//               sell_units: sellUnitsNumber,
//               sell_amount: sellAmount,
//               indirect_charges: indirectCharges,
//               date: batch.date,
//             }),
//           });
//           if (!res.ok) {
//             console.error('sellstocks POST failed for', row.stock_name);
//             continue;
//           }
//         } catch (err) {
//           console.error('sellstocks POST error', err);
//           continue;
//         }

//         // 2) Invoice record — sell type, mirrors handleSellStockSubmit exactly
//         try {
//           await fetch(`${process.env.REACT_APP_API_URL}/auth/invoice`, {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({
//               farm: farmName,
//               party: partyId,
//               invoice_type: 'sell',
//               date: batch.date,
//               datainvoice: JSON.stringify([
//                 {
//                   stock_id: row.stock_name,
//                   stock_name: row.stock_name,
//                   category,
//                   sell_units: sellUnitsNumber,
//                   sell_amount: sellAmount,
//                   indirect_charges: indirectCharges,
//                   total_amount: sellAmount,
//                   date: batch.date,
//                 },
//               ]),
//             }),
//           });
//         } catch (err) {
//           console.error('Invoice POST error', err);
//         }

//         // 3) buysellrecord — mirrors handleSellStockSubmit logic
//         try {
//           let perUnitPrice = 0;
//           if (mergedStock) {
//             perUnitPrice = safeNumber(mergedStock.perUnitCharge);
//             if (!perUnitPrice) {
//               const totalAmountVal = parseFloat(mergedStock.total_amount) || 0;
//               // restore sold units to approximate original total
//               const totalUnitsVal = parseFloat(mergedStock.unit) + sellUnitsNumber;
//               perUnitPrice = totalUnitsVal > 0 ? totalAmountVal / totalUnitsVal : 0;
//             }
//           }
//           const totalpurchase = sellUnitsNumber * perUnitPrice;
//           const totalsell = netSale;

//           const latestRes = await fetch(
//             `${process.env.REACT_APP_API_URL}/auth/buysellrecord?_sort=date,id&_order=desc,desc`
//           );
//           const latestList = await latestRes.json();
//           const latestEntry =
//             Array.isArray(latestList) && latestList.length > 0
//               ? latestList[latestList.length - 1]
//               : null;

//           if (latestEntry && latestEntry.totalpurchase !== undefined && latestEntry.id) {
//             const prevTotalSell = safeNumber(latestEntry.totalsell);
//             const newTotalSell = prevTotalSell + totalsell;
//             const newClosingBLC = safeNumber(latestEntry.totalpurchase) - newTotalSell;

//             await fetch(`${process.env.REACT_APP_API_URL}/auth/buysellrecord`, {
//               method: 'PUT',
//               headers: { 'Content-Type': 'application/json' },
//               body: JSON.stringify({
//                 id: latestEntry.id,
//                 date: batch.date,
//                 totalpurchase: latestEntry.totalpurchase,
//                 totalsell: newTotalSell,
//                 closingBLC: newClosingBLC,
//               }),
//             });
//           } else {
//             await fetch(`${process.env.REACT_APP_API_URL}/auth/buysellrecord`, {
//               method: 'POST',
//               headers: { 'Content-Type': 'application/json' },
//               body: JSON.stringify({
//                 date: batch.date,
//                 totalpurchase,
//                 totalsell,
//                 closingBLC: 0 - totalpurchase + totalsell,
//               }),
//             });
//           }
//         } catch (err) {
//           console.error('buysellrecord error', err);
//         }

//         // 4) usermeta "remaining" — mirrors handleSellStockSubmit handleUserMetaUpdate
//         try {
//           const umRes = await fetch(
//             `${process.env.REACT_APP_API_URL}/auth/updateusermeta?party_id=${partyId}`
//           );
//           const umList = await umRes.json();
//           const foundMeta = Array.isArray(umList)
//             ? umList.find(
//                 (m: any) =>
//                   m.meta_key === 'remaining' && String(m.party_id) === String(partyId)
//               )
//             : null;

//           if (foundMeta) {
//             const oldVal = safeNumber(foundMeta.meta_value);
//             await fetch(
//               `${process.env.REACT_APP_API_URL}/auth/updateusermeta/${foundMeta.id}`,
//               {
//                 method: 'PUT',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                   meta_key: 'remaining',
//                   meta_value: (oldVal + netSale).toString(),
//                   party_id: partyId,
//                 }),
//               }
//             );
//           } else {
//             const party = partiesList.find((p) => String(p.id) === String(partyId));
//             const baseAmount = safeNumber(party?.total_amount ?? 0);
//             await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta`, {
//               method: 'POST',
//               headers: { 'Content-Type': 'application/json' },
//               body: JSON.stringify({
//                 meta_key: 'remaining',
//                 meta_value: (baseAmount + netSale).toString(),
//                 party_id: partyId,
//               }),
//             });
//           }

//           // Keep local state in sync
//           setTotalAmmountSpend((prev) => (safeNumber(prev) || 0) + netSale);
//         } catch (err) {
//           console.error('usermeta error', err);
//         }
//       }
//     }

//     await fetchParties();
//     // Refresh sell stocks so UI reflects new sales
//     const sellArr = await fetchSellStocks();
//     setSellStocks(sellArr);
//     setShowOcrModal(false);
//   };

//   const handleSellStockSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();
//     if (!sellStockForm.partyId) return alert('Select party');
//     if (!sellStockForm.category) return alert('Select category');
//     if (!sellStockForm.stockId) return alert('Select stock');
//     const sellUnitsNumber = parseFloat(sellStockForm.sellUnits || '0');
//     if (!sellUnitsNumber || isNaN(sellUnitsNumber) || sellUnitsNumber <= 0)
//       return alert('Please enter valid units to sell');
//     if (!selectedStockObj) return alert('Select valid stock');
//     if (sellUnitsNumber > parseFloat(selectedStockObj.unit || '0')) {
//       return alert(
//         `Not enough units available to sell! Available: ${selectedStockObj.unit}, Requested: ${sellUnitsNumber}`
//       );
//     }
//     if (!sellStockForm.date) return alert('Select date for sell');

//     const sellAmount =
//       Number(sellStockForm.sellAmount) > 0
//         ? Number(sellStockForm.sellAmount)
//         : typeof autoAmount !== 'undefined'
//         ? Number(autoAmount)
//         : 0;
//     const indirectCharges = Number(sellStockForm.indirectCharges) || 0;
//     const netSale = sellAmount - indirectCharges;

//     const handleUserMetaUpdate = async () => {
//       try {
//         const usermetaResponse = await fetch(
//           `${process.env.REACT_APP_API_URL}/auth/updateusermeta?party_id=${sellStockForm.partyId}`
//         );
//         const usermetaList = await usermetaResponse.json();
//         const foundMeta = Array.isArray(usermetaList)
//           ? usermetaList.find(
//               (meta: any) =>
//                 meta.meta_key === 'remaining' &&
//                 String(meta.party_id) === String(sellStockForm.partyId)
//             )
//           : undefined;

//         if (foundMeta) {
//           const oldVal = parseFloat(foundMeta.meta_value || '0');
//           const meta_value = (oldVal + netSale).toString();
//           await fetch(
//             `${process.env.REACT_APP_API_URL}/auth/updateusermeta/${foundMeta.id}`,
//             {
//               method: 'PUT',
//               headers: { 'Content-Type': 'application/json' },
//               body: JSON.stringify({
//                 meta_key: 'remaining',
//                 meta_value,
//                 party_id: sellStockForm.partyId,
//               }),
//             }
//           );
//         } else {
//           const oldVal = Number(totalamountspend) || 0;
//           const remaining = (oldVal + netSale).toString();
//           await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta`, {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({
//               meta_key: 'remaining',
//               meta_value: remaining,
//               party_id: sellStockForm.partyId,
//             }),
//           });
//         }
//       } catch (err) {
//         console.error('Usermeta API failed', err);
//       }
//     };

//     setLoading(true);
//     try {
//       const payload = {
//         party_id: sellStockForm.partyId,
//         category: sellStockForm.category,
//         stock_id: sellStockForm.stockId,
//         stock_name: sellStockForm.stockName,
//         sell_units: sellUnitsNumber,
//         sell_amount: sellAmount,
//         indirect_charges: sellStockForm.indirectCharges,
//         date: sellStockForm.date,
//       };

//       const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/sellstocks`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(payload),
//       });
//       const result = await res.json();
//       if (!res.ok) throw new Error(result?.message || 'Failed to sell stock');

//       // Invoice
//       try {
//         const invoiceData = {
//           farm: farmName,
//           party: sellStockForm.partyId,
//           invoice_type: 'sell',
//           date: sellStockForm.date,
//           datainvoice: JSON.stringify([
//             {
//               stock_id: sellStockForm.stockId,
//               stock_name: sellStockForm.stockName,
//               category: sellStockForm.category,
//               sell_units: sellUnitsNumber,
//               sell_amount: sellAmount,
//               indirect_charges: sellStockForm.indirectCharges,
//               total_amount: sellAmount,
//               date: sellStockForm.date,
//             },
//           ]),
//         };
//         await fetch(`${process.env.REACT_APP_API_URL}/auth/invoice`, {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify(invoiceData),
//         });
//       } catch (err) {
//         console.error('Error adding sell invoice:', err);
//       }

//       // buysellrecord
//       try {
//         let perUnitPrice = 0;
//         if (selectedStockObj) {
//           perUnitPrice = Number(selectedStockObj.perUnitCharge);
//           if (!perUnitPrice || isNaN(perUnitPrice)) {
//             const totalAmountVal = parseFloat(selectedStockObj.total_amount) || 0;
//             const totalUnitsVal = parseFloat(selectedStockObj.unit) + sellUnitsNumber;
//             perUnitPrice = totalUnitsVal > 0 ? totalAmountVal / totalUnitsVal : 0;
//           }
//         }
//         const totalpurchase = sellUnitsNumber * perUnitPrice;
//         const totalsell = netSale;

//         const latestRes = await fetch(
//           `${process.env.REACT_APP_API_URL}/auth/buysellrecord?_sort=date,id&_order=desc,desc`
//         );
//         const latestList = await latestRes.json();
//         const latestEntry =
//           Array.isArray(latestList) && latestList.length > 0
//             ? latestList[latestList.length - 1]
//             : null;

//         if (latestEntry && latestEntry.totalpurchase !== undefined && latestEntry.id) {
//           const prevTotalSell = Number(latestEntry.totalsell) || 0;
//           const newTotalSell = prevTotalSell + totalsell;
//           const newClosingBLC =
//             (Number(latestEntry.totalpurchase) || 0) - newTotalSell;

//           await fetch(`${process.env.REACT_APP_API_URL}/auth/buysellrecord`, {
//             method: 'PUT',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({
//               id: latestEntry.id,
//               date: sellStockForm.date,
//               totalpurchase: latestEntry.totalpurchase,
//               totalsell: newTotalSell,
//               closingBLC: newClosingBLC,
//             }),
//           });
//         } else {
//           await fetch(`${process.env.REACT_APP_API_URL}/auth/buysellrecord`, {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({
//               date: sellStockForm.date,
//               totalpurchase,
//               totalsell,
//               closingBLC: 0 - totalpurchase + totalsell,
//             }),
//           });
//         }
//       } catch (err) {
//         console.error('Failed to send buysellrecord', err);
//       }

//       setTotalAmmountSpend((prev) => (Number(prev) || 0) + netSale);
//       await handleUserMetaUpdate();

//       alert('Stock sell recorded successfully!');
//       setSellStockForm({
//         partyId: sellStockForm.partyId,
//         category: '',
//         stockId: '',
//         stockName: '',
//         sellUnits: '',
//         sellAmount: '',
//         indirectCharges: '',
//         date: '',
//       });
//       window.location.reload();
//     } catch (err: any) {
//       alert('Error: ' + (err?.message ?? 'Something went wrong'));
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Stock names list for OcrUploadModal — deduplicated per category for the selected party
//   // Shape: { [category]: string[] }
//   const stockNamesByCategory = useMemo(() => {
//     const result: { [category: string]: string[] } = {};
//     for (const [cat, items] of Object.entries(partyStocksByCat)) {
//       const merged = mergeStocksByName(items);
//       result[cat] = merged.map((s) => s.stock_name);
//     }
//     return result;
//   }, [partyStocksByCat]);

//   // ------------ UI ---------------
//   return (
//     <div className="w-full min-h-[80vh] flex flex-col items-center justify-center bg-gradient-to-br from-[#f6fcf8] to-[#fff8ef] py-10 transition-colors">
//       <div className="w-full max-w-2xl bg-white shadow-2xl rounded-3xl px-6 sm:px-12 py-10 border-4 border-[color:var(--primary)]/10 relative overflow-hidden duo-form-glow">
//         <div className="hidden absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[var(--primary)] to-[var(--secondary)] rounded-t-3xl animate-fadein" />

//         <button
//           type="button"
//           onClick={() => setShowOcrModal(true)}
//           className="flex items-center gap-2 text-[14px] font-[500] text-white bg-gradient-to-r from-[#6366F1] to-[#8B5CF6] py-2 px-5 rounded-[8px] shadow hover:opacity-90 transition duration-150"
//         >
//           <svg
//             className="w-5 h-5 text-white"
//             fill="none"
//             stroke="currentColor"
//             strokeWidth={2}
//             viewBox="0 0 24 24"
//           >
//             <rect
//               x="3"
//               y="4"
//               width="18"
//               height="16"
//               rx="2"
//               stroke="currentColor"
//               strokeWidth="2"
//               fill="#fff"
//               fillOpacity=".1"
//             />
//             <path
//               d="M8 2v4M16 2v4M3 10h18"
//               stroke="currentColor"
//               strokeWidth="2"
//               strokeLinecap="round"
//             />
//             <circle
//               cx="12"
//               cy="14"
//               r="3"
//               stroke="currentColor"
//               strokeWidth="2"
//               fill="none"
//             />
//           </svg>
//           Scan Document
//         </button>

//         {showOcrModal ? (
//           <OcrUploadModal
//             partiesList={partiesList}
//             // Pass the deduplicated stock names grouped by category
//             stockNamesByCategory={stockNamesByCategory}
//             onSubmit={handleOcrSubmit as any}
//             onClose={() => setShowOcrModal(false)}
//             apiUrl={process.env.REACT_APP_API_URL || ''}
//           />
//         ) : null}

//         <h2 className="text-center text-4xl md:text-5xl font-extrabold mb-2 tracking-tighter duo-gradient-text drop-shadow-xl select-none">
//           Sell Stocks
//         </h2>
//         <p className="text-center text-gray-600 mb-7 italic bg-[color:var(--primary)]/10 rounded-xl px-3 py-2 text-base shadow border-l-4 border-[color:var(--secondary)]/30 font-medium">
//           <span className="inline-block px-2 py-1 bg-gradient-to-tr from-[color:var(--primary)]/10 to-[color:var(--secondary)]/10 rounded">
//             Record a new stock sale transaction
//           </span>
//           <br />
//           <span className="font-sans text-sm text-gray-400">
//             Select party, then category, then stock.
//             <br />
//             (Party can be preselected via URL)
//           </span>
//         </p>
//         <form
//           onSubmit={handleSellStockSubmit}
//           className="grid gap-8 grid-cols-1 md:grid-cols-2 animate-fadeInUp"
//           autoComplete="off"
//         >
//           {/* Party */}
//           <div className="col-span-1">
//             <label
//               htmlFor="partyId"
//               className="block mb-2 font-bold text-[color:var(--primary)] text-lg flex items-center gap-2 hover:text-[color:var(--secondary)] transition"
//             >
//               <span role="img" aria-label="party">👤</span> Party Name
//             </label>
//             <div className="relative">
//               <select
//                 name="partyId"
//                 id="partyId"
//                 value={sellStockForm.partyId}
//                 onChange={handleFormChange}
//                 className="w-full border-2 border-[color:var(--primary)] bg-[#f8fbf9] rounded-xl px-5 py-3 text-[color:var(--primary)] focus:ring-2 focus:ring-[color:var(--primary)]/60 font-semibold transition-all"
//                 required
//                 style={{ color: 'var(--primary)' }}
//               >
//                 <option value="">Choose Party</option>
//                 {partiesList.map((p) => (
//                   <option key={String(p.id)} value={String(p.id)}>
//                     {p.name}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>

//           {/* Category */}
//           <div className="col-span-1">
//             <label
//               htmlFor="category"
//               className="block mb-2 font-bold text-[color:var(--secondary)] text-lg flex items-center gap-2 hover:text-[color:var(--primary)] transition"
//             >
//               <span role="img" aria-label="category">📂</span> Category
//             </label>
//             <div className="relative">
//               <select
//                 name="category"
//                 id="category"
//                 value={sellStockForm.category}
//                 onChange={handleFormChange}
//                 required
//                 disabled={!sellStockForm.partyId}
//                 className={`w-full border-2 bg-[#fffcf7] border-[color:var(--secondary)] rounded-xl px-5 py-3 text-[color:var(--secondary)] font-semibold focus:ring-2 focus:ring-[color:var(--secondary)]/50 transition-all ${
//                   !sellStockForm.partyId ? 'bg-gray-50 opacity-60 cursor-not-allowed' : ''
//                 }`}
//                 style={{ color: 'var(--secondary)' }}
//               >
//                 <option value="">Select Category</option>
//                 {partyCategories.map((cat) => (
//                   <option key={String(cat)} value={cat}>
//                     {cat}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>

//           {/* Stock Name — now shows deduplicated list */}
//           <div className="col-span-1 md:col-span-2">
//             <label
//               htmlFor="stockId"
//               className="block mb-2 font-bold text-[color:var(--primary)] text-lg flex items-center gap-2 hover:text-[color:var(--secondary)] transition"
//             >
//               <span role="img" aria-label="stock">🏷️</span> Stock Name
//             </label>
//             <div className="relative">
//               <select
//                 name="stockId"
//                 id="stockId"
//                 value={sellStockForm.stockId}
//                 onChange={handleFormChange}
//                 required
//                 disabled={!sellStockForm.category}
//                 className={`w-full border-2 border-[color:var(--primary)] bg-[#f6fbf8] rounded-xl px-5 py-3 text-[color:var(--primary)] font-semibold focus:ring-2 focus:ring-[color:var(--primary)]/50 transition-all ${
//                   !sellStockForm.category ? 'bg-gray-50 opacity-60 cursor-not-allowed' : ''
//                 }`}
//                 style={{ color: 'var(--primary)' }}
//               >
//                 <option value="">Select Stock</option>
//                 {stocksInCurrentCategory.map((stock) => (
//                   <option key={`${stock.category}__${stock.stock_name}`} value={stock.stock_name}>
//                     {stock.stock_name}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             {sellStockForm.category && stocksInCurrentCategory.length === 0 && (
//               <p className="text-xs text-center text-red-500 mt-2 font-mono italic">
//                 No stocks available under this category.
//               </p>
//             )}
//           </div>

//           {/* Units To Sell */}
//           <div className="col-span-1">
//             <label
//               htmlFor="sellUnits"
//               className="block mb-2 font-bold text-[color:var(--primary)] text-lg flex items-center gap-2 hover:text-[color:var(--secondary)] transition"
//             >
//               <span role="img" aria-label="units">🔢</span> Units To Sell
//               {selectedStockObj && (
//                 <span className="text-xs ml-2 text-gray-400 font-normal">
//                   (Available:{' '}
//                   <b className="text-[color:var(--secondary)]">{selectedStockObj.unit}</b>)
//                 </span>
//               )}
//             </label>
//             <div className="relative">
//               <input
//                 type="number"
//                 name="sellUnits"
//                 id="sellUnits"
//                 value={sellStockForm.sellUnits}
//                 required
//                 disabled={!sellStockForm.stockId}
//                 min={0}
//                 max={selectedStockObj ? selectedStockObj.unit : undefined}
//                 onChange={handleFormChange}
//                 className="w-full border-2 border-[color:var(--primary)] bg-[#f6fbf8] rounded-xl px-5 py-3 text-[color:var(--primary)] font-medium focus:ring-2 focus:ring-[color:var(--primary)]/40 placeholder-gray-300 transition-all"
//                 placeholder="How many units to sell"
//                 style={{ color: 'var(--primary)' }}
//                 step="any"
//                 inputMode="decimal"
//                 pattern="[0-9.]*"
//               />
//             </div>
//             {sellStockForm.sellUnits &&
//             selectedStockObj &&
//             parseFloat(sellStockForm.sellUnits) > parseFloat(selectedStockObj.unit) ? (
//               <span className="text-xs text-red-600 font-semibold px-2 py-1 inline-block bg-[#ffedf1] rounded mt-1">
//                 Not enough units available!
//               </span>
//             ) : null}
//           </div>

//           {/* Sell Amount */}
//           <div className="col-span-1">
//             <label
//               htmlFor="sellAmount"
//               className="block mb-2 font-bold text-[color:var(--secondary)] text-lg flex items-center gap-2 hover:text-[color:var(--primary)] transition"
//             >
//               <span role="img" aria-label="amount">💰</span> Sell Amount
//               <span className="text-xs bg-[#fff8ef] text-[color:var(--primary)] px-2 py-1 rounded font-mono ml-2">
//                 (Auto: {(autoAmount || 0).toFixed(2)}{' '}
//                 {sellStockForm.sellUnits ? 'calculated' : ''})
//               </span>
//             </label>
//             <div className="relative">
//               <input
//                 type="number"
//                 name="sellAmount"
//                 id="sellAmount"
//                 placeholder={`Auto: ${(autoAmount || 0).toFixed(2)}`}
//                 value={sellStockForm.sellAmount}
//                 min={0}
//                 step="any"
//                 onChange={handleFormChange}
//                 required
//                 disabled={!sellStockForm.stockId}
//                 className="w-full border-2 border-[color:var(--secondary)] bg-[#fff8ef] rounded-xl px-5 py-3 text-[color:var(--secondary)] font-medium focus:ring-2 focus:ring-[color:var(--secondary)]/50 transition-all placeholder-gray-400"
//                 style={{ color: 'var(--secondary)' }}
//                 inputMode="decimal"
//                 pattern="[0-9]*"
//               />
//             </div>
//             <span className="block text-xs text-gray-400 mt-1 font-mono ml-2">
//               Leave blank for auto-calculated. You can adjust if desired.
//             </span>
//           </div>

//           {/* Indirect Charges */}
//           <div className="col-span-1">
//             <label
//               htmlFor="indirectCharges"
//               className="block mb-2 font-bold text-[color:var(--primary)] text-lg flex items-center gap-2 hover:text-[color:var(--secondary)] transition"
//             >
//               <span role="img" aria-label="fees">💸</span> Indirect Charges
//             </label>
//             <div className="relative">
//               <input
//                 type="number"
//                 name="indirectCharges"
//                 id="indirectCharges"
//                 placeholder="Enter indirect charges (if any)"
//                 value={sellStockForm.indirectCharges}
//                 min={0}
//                 step="any"
//                 onChange={handleFormChange}
//                 disabled={!sellStockForm.stockId}
//                 className="w-full border-2 border-[color:var(--primary)] bg-[#f6fbf8] rounded-xl px-5 py-3 text-[color:var(--primary)] font-normal focus:ring-2 focus:ring-[color:var(--primary)]/60 placeholder-gray-300 transition-all"
//                 style={{ color: 'var(--primary)' }}
//               />
//             </div>
//           </div>

//           {/* Date */}
//           <div className="col-span-1">
//             <label
//               htmlFor="date"
//               className="block mb-2 font-bold text-[color:var(--secondary)] text-lg flex items-center gap-2 hover:text-[color:var(--primary)] transition"
//             >
//               <span role="img" aria-label="date">📅</span> Date
//             </label>
//             <div className="relative">
//               <input
//                 type="date"
//                 name="date"
//                 id="date"
//                 value={sellStockForm.date}
//                 onChange={handleFormChange}
//                 required
//                 className="w-full border-2 border-[color:var(--secondary)] bg-[#fff8ef] rounded-xl px-5 py-3 text-[color:var(--secondary)] font-medium focus:ring-2 focus:ring-[color:var(--secondary)]/40 transition-all"
//                 disabled={!sellStockForm.stockId}
//                 style={{ color: 'var(--secondary)' }}
//               />
//             </div>
//           </div>

//           {/* Submit */}
//           <div className="col-span-1 md:col-span-2 flex flex-col md:flex-row-reverse justify-between items-center gap-3 pt-2">
//             <button
//               type="submit"
//               disabled={loading}
//               className="px-10 py-3 rounded-full bg-gradient-to-r from-[color:var(--primary)] to-[color:var(--secondary)] text-white font-extrabold text-2xl transform hover:scale-105 active:scale-100 transition-all focus:outline-none focus:ring-4 focus:ring-[color:var(--primary)]/50 disabled:opacity-60 flex items-center gap-2 border-b-4 border-[color:var(--secondary)]/50"
//               style={{
//                 boxShadow: '0 8px 48px 3px #94efd990, 0 3px 15px -2px #f8bb498f',
//               }}
//             >
//               {loading ? (
//                 <>
//                   <svg
//                     className="animate-spin mr-2 h-6 w-6 text-white"
//                     xmlns="http://www.w3.org/2000/svg"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                   >
//                     <circle
//                       className="opacity-25"
//                       cx="12"
//                       cy="12"
//                       r="10"
//                       stroke="currentColor"
//                       strokeWidth="4"
//                     />
//                     <path
//                       className="opacity-75"
//                       fill="currentColor"
//                       d="M4 12a8 8 0 018-8v8z"
//                     />
//                   </svg>
//                   Selling...
//                 </>
//               ) : (
//                 <>
//                   <span role="img" aria-label="sell">💸</span> Sell Stock
//                 </>
//               )}
//             </button>
//           </div>
//         </form>
//       </div>
//       <style>{`
//         :root {
//           --primary: ${PRIMARY};
//           --secondary: ${SECONDARY};
//         }
//         .duo-gradient-text {
//           background: linear-gradient(90deg, var(--primary), var(--secondary) 100%);
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//           background-clip: text;
//         }
//         @media (max-width: 600px){
//           .duo-form-glow:before, .duo-form-glow:after{display:none;}
//         }
//         .animate-fadein{
//           animation: fadeInLeft 0.7s cubic-bezier(.29,.31,.41,1.41);
//         }
//         @keyframes fadeInLeft{
//           0%{ opacity:0; transform:translateX(-100%);}
//           80%{ opacity:0.2;}
//           100%{ opacity:1; transform: translateX(0);}
//         }
//         .animate-fadeInUp {
//           animation: fadeInUp 1.0s cubic-bezier(.38,.33,.52,1.42);
//         }
//         @keyframes fadeInUp {
//           0% {opacity: 0; transform: translateY(40px);}
//           100% {opacity: 1; transform: translateY(0);}
//         }
//       `}</style>
//     </div>
//   );
// };

// export default SellStocksPage;

import React, { useEffect, useState, useMemo, useCallback } from 'react';
import parties from '../data/party';
import stockdata from '../data/stock';
import sellstocks from '../data/sellstocks';
import settingapi from '../data/setting';
import OcrUploadModal from './OcrUploadModal';

interface Party {
  id: number;
  name: string;
  total_amount?: number | string;
}

type SellStockRecord = {
  id: number;
  party_id: number;
  category: string;
  stock_id: string;
  stock_name: string;
  sell_units: string;
  sell_amount: string;
  indirect_charges: string;
  date: string;
  catrgories?: string;
};

interface StockDBCategoryItem {
  id: number | string;
  investment_type: string;
  category: string;
  stock_name: string;
  unit: string;
  total_amount: string;
  indirect_charges: string;
  perUnitCharge: string;
}

// Deduplicated stock with merged units/amounts across DB rows
interface MergedStockItem {
  stock_name: string;
  category: string;
  unit: string;          // sum of remaining units across all rows
  total_amount: string;  // sum of total_amount across all rows
  indirect_charges: string;
  perUnitCharge: string; // weighted average
  investment_type: string;
  // Keep ids of all source rows for reference
  sourceIds: (number | string)[];
}

type SellStockFormState = {
  partyId: string;
  category: string;
  stockId: string | number;
  stockName: string;
  sellUnits: string;
  sellAmount: string;
  indirectCharges: string;
  date: string;
};

const PRIMARY = '#17946B';
const SECONDARY = '#FF9500';

async function fetchSellStocks(): Promise<SellStockRecord[]> {
  try {
    const res = await sellstocks();
    if (res && typeof res.json === 'function') {
      if (!res.ok) return [];
      const data = await res.json();
      return Array.isArray(data) ? data : [];
    } else if (Array.isArray(res)) {
      return res;
    }
    return [];
  } catch {
    return [];
  }
}

function getSellUnitsForStock(
  sellStocks: SellStockRecord[],
  partyId: string,
  category: string,
  stockName: string
): number {
  return sellStocks.reduce((sum, rec) => {
    if (
      String(rec.party_id) === String(partyId) &&
      String(rec.category) === String(category) &&
      String(rec.stock_id) === String(stockName)
    ) {
      return sum + parseFloat(rec.sell_units || '0');
    }
    return sum;
  }, 0);
}

function getPartyStocksAdjusted(
  stocksDbRows: any[],
  sellStocks: SellStockRecord[],
  partyId: string
) {
  let result: { [category: string]: StockDBCategoryItem[] } = {};
  for (const row of stocksDbRows) {
    if (String(row.party_id) !== String(partyId)) continue;
    let catsArr: StockDBCategoryItem[] = [];
    if (typeof row.categories === 'string') {
      try {
        const parsed = JSON.parse(row.categories);
        catsArr = Array.isArray(parsed) ? parsed : [];
      } catch {
        catsArr = [];
      }
    } else if (Array.isArray(row.categories)) {
      catsArr = row.categories as StockDBCategoryItem[];
    }
    for (const item of catsArr) {
      const soldUnits = getSellUnitsForStock(
        sellStocks,
        partyId,
        item.category,
        item.stock_name
      );
      let origUnit = parseFloat(item.unit || '0');
      let remainingUnit = origUnit - soldUnits;
      const adjustedItem = {
        ...item,
        unit: remainingUnit >= 0 ? String(remainingUnit) : '0',
      };
      if (!result[item.category]) result[item.category] = [];
      result[item.category].push(adjustedItem);
    }
  }
  return result;
}

/**
 * Merges duplicate stock entries (same stock_name + category) across multiple
 * DB rows into a single item, summing units and amounts, computing weighted avg
 * perUnitCharge, and dropping entries with 0 remaining units.
 */
function mergeStocksByName(items: StockDBCategoryItem[]): MergedStockItem[] {
  const map = new Map<string, MergedStockItem>();

  for (const item of items) {
    const key = `${item.category}__${item.stock_name}`;
    const unit = parseFloat(item.unit || '0');
    const totalAmount = parseFloat(item.total_amount || '0');
    const indirectCharges = parseFloat(item.indirect_charges || '0');

    if (map.has(key)) {
      const existing = map.get(key)!;
      const newUnit = parseFloat(existing.unit) + unit;
      const newTotal = parseFloat(existing.total_amount) + totalAmount;
      const newIndirect = parseFloat(existing.indirect_charges) + indirectCharges;
      const newPerUnit = newUnit > 0 ? ((newTotal + newIndirect) / newUnit).toFixed(2) : '0.00';

      map.set(key, {
        ...existing,
        unit: String(newUnit),
        total_amount: String(newTotal),
        indirect_charges: String(newIndirect),
        perUnitCharge: newPerUnit,
        sourceIds: [...existing.sourceIds, item.id],
      });
    } else {
      map.set(key, {
        stock_name: item.stock_name,
        category: item.category,
        unit: String(unit),
        total_amount: String(totalAmount),
        indirect_charges: String(indirectCharges),
        perUnitCharge: item.perUnitCharge || (unit > 0 ? ((totalAmount + indirectCharges) / unit).toFixed(2) : '0.00'),
        investment_type: item.investment_type,
        sourceIds: [item.id],
      });
    }
  }

  // Filter out stocks with 0 remaining units
  return Array.from(map.values()).filter(
    s => !!(s.stock_name && s.stock_name.trim()) && parseFloat(s.unit) > 0
  );
}

function safeNumber(v: any): number {
  const n = parseFloat(String(v));
  return isNaN(n) ? 0 : n;
}

const SellStocksPage = () => {
  const [partiesList, setPartiesList] = useState<Party[]>([]);
  const [sellStocks, setSellStocks] = useState<SellStockRecord[]>([]);
  const [stocksDataDb, setStocksDataDb] = useState<any[]>([]);
  const [totalamountspend, setTotalAmmountSpend] = useState<Number>();
  const [showOcrModal, setShowOcrModal] = useState(false);
  const [farmName, setFarmName] = useState<string>();

  const [sellStockForm, setSellStockForm] = useState<SellStockFormState>({
    partyId: '',
    category: '',
    stockId: '',
    stockName: '',
    sellUnits: '',
    sellAmount: '',
    indirectCharges: '',
    date: '',
  });
  const [autoAmount, setAutoAmount] = useState<number>(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function fetchSettingsApi() {
      try {
        const res = await settingapi();
        if (Array.isArray(res)) {
          const farmSetting = res.find((item: any) => item.meta_key === 'farm');
          if (farmSetting && farmSetting.meta_value !== undefined) {
            let farmObj = {};
            try {
              farmObj =
                typeof farmSetting.meta_value === 'string'
                  ? JSON.parse(farmSetting.meta_value)
                  : farmSetting.meta_value;
            } catch {}
            if (
              farmObj &&
              typeof farmObj === 'object' &&
              farmObj !== null &&
              'name' in farmObj &&
              typeof (farmObj as { name?: unknown }).name === 'string'
            ) {
              setFarmName((farmObj as { name: string }).name);
            }
          }
        }
      } catch {}
    }
    fetchSettingsApi();
  }, []);

  useEffect(() => {
    async function loadSellStocks() {
      const sellArr = await fetchSellStocks();
      setSellStocks(sellArr);
    }
    loadSellStocks();
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const partyId = urlParams.get('party') || '';
    setSellStockForm((s) => ({ ...s, partyId }));
  }, []);

  useEffect(() => {
    (async () => {
      const pts = await parties();
      setPartiesList(Array.isArray(pts) ? pts : []);
      const db = await stockdata();
      setStocksDataDb(Array.isArray(db) ? db : []);
    })();
  }, []);

  async function fetchParties() {
    const pts = await parties();
    setPartiesList(Array.isArray(pts) ? pts : []);
  }

  // Raw (unadjusted) stocks by category for the selected party
  const partyStocksByCat = useMemo(
    () => getPartyStocksAdjusted(stocksDataDb, sellStocks, sellStockForm.partyId),
    [stocksDataDb, sellStocks, sellStockForm.partyId]
  );

  const partyCategories = useMemo(() => Object.keys(partyStocksByCat), [partyStocksByCat]);

  // Raw items for the selected category (may have duplicates)
  const rawStocksInCategory = useMemo(
    () =>
      sellStockForm.category ? partyStocksByCat[sellStockForm.category] || [] : [],
    [sellStockForm.category, partyStocksByCat]
  );

  // Deduplicated, merged stocks — one entry per unique stock_name with 0-unit entries removed
  const stocksInCurrentCategory = useMemo(
    () => mergeStocksByName(rawStocksInCategory),
    [rawStocksInCategory]
  );

  // The selected merged stock object
  const selectedStockObj = useMemo(
    () =>
      stocksInCurrentCategory.find(
        (s) => String(s.stock_name) === String(sellStockForm.stockName)
      ),
    [sellStockForm.stockName, stocksInCurrentCategory]
  );

  useEffect(() => {
    const unitsNum = parseFloat(sellStockForm.sellUnits || '0');
    if (!selectedStockObj || isNaN(unitsNum) || unitsNum <= 0) {
      setAutoAmount(0);
      return;
    }
    const totalAvailableUnits = parseFloat(selectedStockObj.unit);
    const amount = parseFloat(selectedStockObj.total_amount);
    const amt = totalAvailableUnits > 0 ? (amount / totalAvailableUnits) * unitsNum : 0;
    setAutoAmount(amt);
  }, [sellStockForm.sellUnits, selectedStockObj]);

  const fetchUserRemainingBalance = useCallback(
    async (partyId: string) => {
      if (!partyId) {
        setTotalAmmountSpend(0);
        return;
      }
      try {
        const usermetaResponse = await fetch(
          `${process.env.REACT_APP_API_URL}/auth/updateusermeta`
        );
        const usermetaList = await usermetaResponse.json();
        const foundMeta = usermetaList.find(
          (meta: any) =>
            meta.meta_key === 'remaining' && String(meta.party_id) === String(partyId)
        );
        if (foundMeta) {
          setTotalAmmountSpend(Number(foundMeta.meta_value));
        } else {
          const party = partiesList.find((p) => String(p.id) === String(partyId));
          setTotalAmmountSpend(Number(party?.total_amount || 0));
        }
      } catch (err) {
        console.error('Error fetching usermeta:', err);
        setTotalAmmountSpend(0);
      }
    },
    [partiesList]
  );

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const partyId = urlParams.get('party') || '';
    fetchUserRemainingBalance(partyId);
  }, [fetchUserRemainingBalance]);

  // --- UI EVENT HANDLERS ---
  const handleFormChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    if (name === 'sellUnits') {
      if (selectedStockObj) {
        const maxUnits = parseFloat(selectedStockObj.unit || '0');
        if (value === '' || value === undefined) {
          setSellStockForm((s) => ({ ...s, sellUnits: '' }));
          return;
        }
        const entered = parseFloat(value);
        if (isNaN(entered) || entered < 0) return;
        if (entered > maxUnits) {
          setSellStockForm((s) => ({ ...s, sellUnits: maxUnits.toString() }));
          return;
        }
        setSellStockForm((s) => ({ ...s, sellUnits: value }));
        return;
      }
    }

    if (name === 'sellAmount') {
      if (selectedStockObj) {
        if (value === '' || value === undefined) {
          setSellStockForm((s) => ({ ...s, sellAmount: '' }));
          return;
        }
        const entered = parseFloat(value);
        if (isNaN(entered) || entered < 0) return;
        setSellStockForm((s) => ({ ...s, sellAmount: value }));
        return;
      }
    }

    let patch: Partial<SellStockFormState> = { [name]: value };
    if (name === 'partyId') {
      patch.category = '';
      patch.stockId = '';
      patch.stockName = '';
      patch.sellUnits = '';
      patch.sellAmount = '';
      patch.date = '';
    }
    if (name === 'category') {
      patch.stockId = '';
      patch.stockName = '';
      patch.sellUnits = '';
      patch.sellAmount = '';
    }
    if (name === 'stockId') {
      // value is stock_name (used as the option value)
      const found = stocksInCurrentCategory.find(
        (s) => String(s.stock_name) === value
      );
      patch.stockName = found ? found.stock_name : '';
      patch.stockId = found ? found.stock_name : '';
    }
    setSellStockForm((s) => ({ ...s, ...patch }));
  };

  // ─── OCR submit — mirrors handleSellStockSubmit for sell flow ───────────────
  // NOTE: OcrUploadModal batches are purchase records (buy flow).
  // This handler processes each OCR batch row as a SELL transaction,
  // matching the same invoice / buysellrecord / usermeta pattern used in
  // handleSellStockSubmit.
  const handleOcrSubmit = async ({
    partyId,
    category,
    batches,
  }: {
    partyId: string;
    category: string;
    batches: { date: string; rows: any[] }[];
  }): Promise<void> => {
    if (!partyId) { alert('Please select a party'); return; }
    if (!category) { alert('Please select a category'); return; }

    for (const batch of batches) {
      if (!batch.date) continue;
      const validRows = batch.rows.filter((r: any) => r.stock_name?.trim());
      if (!validRows.length) continue;

      for (const row of validRows) {
        // Resolve the merged stock to get accurate available units & per-unit price
        const mergedStock = stocksInCurrentCategory.find(
          (s) => s.stock_name === row.stock_name && s.category === category
        );

        const sellUnitsNumber = safeNumber(row.sell_units ?? row.unit);
        if (!sellUnitsNumber || sellUnitsNumber <= 0) continue;

        if (mergedStock) {
          const available = parseFloat(mergedStock.unit);
          if (sellUnitsNumber > available) {
            alert(
              `Not enough units for "${row.stock_name}". ` +
              `Available: ${available}, Requested: ${sellUnitsNumber}`
            );
            continue;
          }
        }

        // Determine sell amount — prefer explicit value, else auto-calculate
        let sellAmount = safeNumber(row.sell_amount ?? row.total_amount);
        if (!sellAmount && mergedStock) {
          const availableUnits = parseFloat(mergedStock.unit);
          const totalAmt = parseFloat(mergedStock.total_amount);
          sellAmount =
            availableUnits > 0 ? (totalAmt / availableUnits) * sellUnitsNumber : 0;
        }

        const indirectCharges = safeNumber(row.indirect_charges ?? 0);
        const netSale = sellAmount - indirectCharges;

        // 1) Main sellstocks record
        try {
          const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/sellstocks`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              party_id: partyId,
              category,
              stock_id: row.stock_name,    // stock_id stored as name, same as handleSellStockSubmit
              stock_name: row.stock_name,
              sell_units: sellUnitsNumber,
              sell_amount: sellAmount,
              indirect_charges: indirectCharges,
              date: batch.date,
            }),
          });
          if (!res.ok) {
            console.error('sellstocks POST failed for', row.stock_name);
            continue;
          }
        } catch (err) {
          console.error('sellstocks POST error', err);
          continue;
        }

        // 2) Invoice record — sell type, mirrors handleSellStockSubmit exactly
        try {
          await fetch(`${process.env.REACT_APP_API_URL}/auth/invoice`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              farm: farmName,
              party: partyId,
              invoice_type: 'sell',
              date: batch.date,
              datainvoice: JSON.stringify([
                {
                  stock_id: row.stock_name,
                  stock_name: row.stock_name,
                  category,
                  sell_units: sellUnitsNumber,
                  sell_amount: sellAmount,
                  indirect_charges: indirectCharges,
                  total_amount: sellAmount,
                  date: batch.date,
                },
              ]),
            }),
          });
        } catch (err) {
          console.error('Invoice POST error', err);
        }

        // 3) buysellrecord — mirrors handleSellStockSubmit logic
        try {
          let perUnitPrice = 0;
          if (mergedStock) {
            perUnitPrice = safeNumber(mergedStock.perUnitCharge);
            if (!perUnitPrice) {
              const totalAmountVal = parseFloat(mergedStock.total_amount) || 0;
              // restore sold units to approximate original total
              const totalUnitsVal = parseFloat(mergedStock.unit) + sellUnitsNumber;
              perUnitPrice = totalUnitsVal > 0 ? totalAmountVal / totalUnitsVal : 0;
            }
          }
          const totalpurchase = sellUnitsNumber * perUnitPrice;
          const totalsell = netSale;

          const latestRes = await fetch(
            `${process.env.REACT_APP_API_URL}/auth/buysellrecord?_sort=date,id&_order=desc,desc`
          );
          const latestList = await latestRes.json();
          const latestEntry =
            Array.isArray(latestList) && latestList.length > 0
              ? latestList[latestList.length - 1]
              : null;

          if (latestEntry && latestEntry.totalpurchase !== undefined && latestEntry.id) {
            const prevTotalSell = safeNumber(latestEntry.totalsell);
            const newTotalSell = prevTotalSell + totalsell;
            const newClosingBLC = safeNumber(latestEntry.totalpurchase) - newTotalSell;

            await fetch(`${process.env.REACT_APP_API_URL}/auth/buysellrecord`, {
              method: 'PUT',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: latestEntry.id,
                date: batch.date,
                totalpurchase: latestEntry.totalpurchase,
                totalsell: newTotalSell,
                closingBLC: newClosingBLC,
              }),
            });
          } else {
            await fetch(`${process.env.REACT_APP_API_URL}/auth/buysellrecord`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                date: batch.date,
                totalpurchase,
                totalsell,
                closingBLC: 0 - totalpurchase + totalsell,
              }),
            });
          }
        } catch (err) {
          console.error('buysellrecord error', err);
        }

        // 4) usermeta "remaining" — mirrors handleSellStockSubmit handleUserMetaUpdate
        try {
          const umRes = await fetch(
            `${process.env.REACT_APP_API_URL}/auth/updateusermeta?party_id=${partyId}`
          );
          const umList = await umRes.json();
          const foundMeta = Array.isArray(umList)
            ? umList.find(
                (m: any) =>
                  m.meta_key === 'remaining' && String(m.party_id) === String(partyId)
              )
            : null;

          if (foundMeta) {
            const oldVal = safeNumber(foundMeta.meta_value);
            await fetch(
              `${process.env.REACT_APP_API_URL}/auth/updateusermeta/${foundMeta.id}`,
              {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  meta_key: 'remaining',
                  meta_value: (oldVal + netSale).toString(),
                  party_id: partyId,
                }),
              }
            );
          } else {
            const party = partiesList.find((p) => String(p.id) === String(partyId));
            const baseAmount = safeNumber(party?.total_amount ?? 0);
            await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                meta_key: 'remaining',
                meta_value: (baseAmount + netSale).toString(),
                party_id: partyId,
              }),
            });
          }

          // Keep local state in sync
          setTotalAmmountSpend((prev) => (safeNumber(prev) || 0) + netSale);
        } catch (err) {
          console.error('usermeta error', err);
        }
      }
    }

    await fetchParties();
    // Refresh sell stocks so UI reflects new sales
    const sellArr = await fetchSellStocks();
    setSellStocks(sellArr);
    setShowOcrModal(false);
  };

  const handleSellStockSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!sellStockForm.partyId) return alert('Select party');
    if (!sellStockForm.category) return alert('Select category');
    if (!sellStockForm.stockId) return alert('Select stock');
    const sellUnitsNumber = parseFloat(sellStockForm.sellUnits || '0');
    if (!sellUnitsNumber || isNaN(sellUnitsNumber) || sellUnitsNumber <= 0)
      return alert('Please enter valid units to sell');
    if (!selectedStockObj) return alert('Select valid stock');
    if (sellUnitsNumber > parseFloat(selectedStockObj.unit || '0')) {
      return alert(
        `Not enough units available to sell! Available: ${selectedStockObj.unit}, Requested: ${sellUnitsNumber}`
      );
    }
    if (!sellStockForm.date) return alert('Select date for sell');

    const sellAmount =
      Number(sellStockForm.sellAmount) > 0
        ? Number(sellStockForm.sellAmount)
        : typeof autoAmount !== 'undefined'
        ? Number(autoAmount)
        : 0;
    const indirectCharges = Number(sellStockForm.indirectCharges) || 0;
    const netSale = sellAmount - indirectCharges;

    const handleUserMetaUpdate = async () => {
      try {
        const usermetaResponse = await fetch(
          `${process.env.REACT_APP_API_URL}/auth/updateusermeta?party_id=${sellStockForm.partyId}`
        );
        const usermetaList = await usermetaResponse.json();
        const foundMeta = Array.isArray(usermetaList)
          ? usermetaList.find(
              (meta: any) =>
                meta.meta_key === 'remaining' &&
                String(meta.party_id) === String(sellStockForm.partyId)
            )
          : undefined;

        if (foundMeta) {
          const oldVal = parseFloat(foundMeta.meta_value || '0');
          const meta_value = (oldVal + netSale).toString();
          await fetch(
            `${process.env.REACT_APP_API_URL}/auth/updateusermeta/${foundMeta.id}`,
            {
              method: 'PUT',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                meta_key: 'remaining',
                meta_value,
                party_id: sellStockForm.partyId,
              }),
            }
          );
        } else {
          const oldVal = Number(totalamountspend) || 0;
          const remaining = (oldVal + netSale).toString();
          await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              meta_key: 'remaining',
              meta_value: remaining,
              party_id: sellStockForm.partyId,
            }),
          });
        }
      } catch (err) {
        console.error('Usermeta API failed', err);
      }
    };

    setLoading(true);
    try {
      const payload = {
        party_id: sellStockForm.partyId,
        category: sellStockForm.category,
        stock_id: sellStockForm.stockId,
        stock_name: sellStockForm.stockName,
        sell_units: sellUnitsNumber,
        sell_amount: sellAmount,
        indirect_charges: sellStockForm.indirectCharges,
        date: sellStockForm.date,
      };

      const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/sellstocks`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const result = await res.json();
      if (!res.ok) throw new Error(result?.message || 'Failed to sell stock');

      // Invoice
      try {
        const invoiceData = {
          farm: farmName,
          party: sellStockForm.partyId,
          invoice_type: 'sell',
          date: sellStockForm.date,
          datainvoice: JSON.stringify([
            {
              stock_id: sellStockForm.stockId,
              stock_name: sellStockForm.stockName,
              category: sellStockForm.category,
              sell_units: sellUnitsNumber,
              sell_amount: sellAmount,
              indirect_charges: sellStockForm.indirectCharges,
              total_amount: sellAmount,
              date: sellStockForm.date,
            },
          ]),
        };
        await fetch(`${process.env.REACT_APP_API_URL}/auth/invoice`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(invoiceData),
        });
      } catch (err) {
        console.error('Error adding sell invoice:', err);
      }

      // buysellrecord
      try {
        let perUnitPrice = 0;
        if (selectedStockObj) {
          perUnitPrice = Number(selectedStockObj.perUnitCharge);
          if (!perUnitPrice || isNaN(perUnitPrice)) {
            const totalAmountVal = parseFloat(selectedStockObj.total_amount) || 0;
            const totalUnitsVal = parseFloat(selectedStockObj.unit) + sellUnitsNumber;
            perUnitPrice = totalUnitsVal > 0 ? totalAmountVal / totalUnitsVal : 0;
          }
        }
        const totalpurchase = sellUnitsNumber * perUnitPrice;
        const totalsell = netSale;

        const latestRes = await fetch(
          `${process.env.REACT_APP_API_URL}/auth/buysellrecord?_sort=date,id&_order=desc,desc`
        );
        const latestList = await latestRes.json();
        const latestEntry =
          Array.isArray(latestList) && latestList.length > 0
            ? latestList[latestList.length - 1]
            : null;

        if (latestEntry && latestEntry.totalpurchase !== undefined && latestEntry.id) {
          const prevTotalSell = Number(latestEntry.totalsell) || 0;
          const newTotalSell = prevTotalSell + totalsell;
          const newClosingBLC =
            (Number(latestEntry.totalpurchase) || 0) - newTotalSell;

          await fetch(`${process.env.REACT_APP_API_URL}/auth/buysellrecord`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: latestEntry.id,
              date: sellStockForm.date,
              totalpurchase: latestEntry.totalpurchase,
              totalsell: newTotalSell,
              closingBLC: newClosingBLC,
            }),
          });
        } else {
          await fetch(`${process.env.REACT_APP_API_URL}/auth/buysellrecord`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              date: sellStockForm.date,
              totalpurchase,
              totalsell,
              closingBLC: 0 - totalpurchase + totalsell,
            }),
          });
        }
      } catch (err) {
        console.error('Failed to send buysellrecord', err);
      }

      setTotalAmmountSpend((prev) => (Number(prev) || 0) + netSale);
      await handleUserMetaUpdate();

      alert('Stock sell recorded successfully!');
      setSellStockForm({
        partyId: sellStockForm.partyId,
        category: '',
        stockId: '',
        stockName: '',
        sellUnits: '',
        sellAmount: '',
        indirectCharges: '',
        date: '',
      });
      window.location.reload();
    } catch (err: any) {
      alert('Error: ' + (err?.message ?? 'Something went wrong'));
    } finally {
      setLoading(false);
    }
  };

  // OcrUploadModal reads `p?.categories` from each party to build its Category dropdown.
  // Our Party type doesn't include categories, so we enrich the list here from stocksDataDb.
  const partiesListWithCategories = useMemo(() => {
    return partiesList.map(party => {
      const cats = new Set<string>();
      for (const row of stocksDataDb) {
        if (String(row.party_id) !== String(party.id)) continue;
        let arr: any[] = [];
        try {
          arr = typeof row.categories === 'string'
            ? JSON.parse(row.categories)
            : Array.isArray(row.categories) ? row.categories : [];
        } catch { arr = []; }
        for (const item of arr) {
          if (item?.category) cats.add(item.category);
        }
      }
      return { ...party, categories: Array.from(cats) };
    });
  }, [partiesList, stocksDataDb]);

  // OcrUploadModal expects { id: number; name: string }[] for stocksnames / mutualsnames.
  // Build from ALL rows in stocksDataDb (not just selected party) so the modal's
  // react-select dropdown has the full list regardless of which party is picked.
  //   - mutualsnames → categories containing "mutual" (case-insensitive)
  //   - stocksnames  → everything else
  const { stocksnames, mutualsnames } = useMemo(() => {
    const stocksSet = new Map<string, { id: number; name: string }>();
    const mutualsSet = new Map<string, { id: number; name: string }>();
    let counter = 1;

    for (const row of stocksDataDb) {
      let arr: StockDBCategoryItem[] = [];
      try {
        arr = typeof row.categories === 'string'
          ? JSON.parse(row.categories)
          : Array.isArray(row.categories) ? row.categories : [];
      } catch { arr = []; }

      for (const item of arr) {
        if (!item?.stock_name?.trim()) continue;
        const isMutual = item.category?.toLowerCase().includes('mutual');
        const target = isMutual ? mutualsSet : stocksSet;
        if (!target.has(item.stock_name)) {
          target.set(item.stock_name, { id: counter++, name: item.stock_name });
        }
      }
    }

    return {
      stocksnames: Array.from(stocksSet.values()),
      mutualsnames: Array.from(mutualsSet.values()),
    };
  }, [stocksDataDb]);

  // ------------ UI ---------------
  return (
    <div className="w-full min-h-[80vh] flex flex-col items-center justify-center bg-gradient-to-br from-[#f6fcf8] to-[#fff8ef] py-10 transition-colors">
      <div className="w-full max-w-2xl bg-white shadow-2xl rounded-3xl px-6 sm:px-12 py-10 border-4 border-[color:var(--primary)]/10 relative overflow-hidden duo-form-glow">
        <div className="hidden absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[var(--primary)] to-[var(--secondary)] rounded-t-3xl animate-fadein" />

        <button
          type="button"
          onClick={() => setShowOcrModal(true)}
          className="flex items-center gap-2 text-[14px] font-[500] text-white bg-gradient-to-r from-[#6366F1] to-[#8B5CF6] py-2 px-5 rounded-[8px] shadow hover:opacity-90 transition duration-150"
        >
          <svg
            className="w-5 h-5 text-white"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            viewBox="0 0 24 24"
          >
            <rect
              x="3"
              y="4"
              width="18"
              height="16"
              rx="2"
              stroke="currentColor"
              strokeWidth="2"
              fill="#fff"
              fillOpacity=".1"
            />
            <path
              d="M8 2v4M16 2v4M3 10h18"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <circle
              cx="12"
              cy="14"
              r="3"
              stroke="currentColor"
              strokeWidth="2"
              fill="none"
            />
          </svg>
          Scan Document
        </button>

        {showOcrModal ? (
          <OcrUploadModal
            partiesList={partiesListWithCategories}
            stocksnames={stocksnames}
            mutualsnames={mutualsnames}
            onSubmit={handleOcrSubmit as any}
            onClose={() => setShowOcrModal(false)}
            apiUrl={process.env.REACT_APP_API_URL || ''}
          />
        ) : null}

        <h2 className="text-center text-4xl md:text-5xl font-extrabold mb-2 tracking-tighter duo-gradient-text drop-shadow-xl select-none">
          Sell Stocks
        </h2>
        <p className="text-center text-gray-600 mb-7 italic bg-[color:var(--primary)]/10 rounded-xl px-3 py-2 text-base shadow border-l-4 border-[color:var(--secondary)]/30 font-medium">
          <span className="inline-block px-2 py-1 bg-gradient-to-tr from-[color:var(--primary)]/10 to-[color:var(--secondary)]/10 rounded">
            Record a new stock sale transaction
          </span>
          <br />
          <span className="font-sans text-sm text-gray-400">
            Select party, then category, then stock.
            <br />
            (Party can be preselected via URL)
          </span>
        </p>
        <form
          onSubmit={handleSellStockSubmit}
          className="grid gap-8 grid-cols-1 md:grid-cols-2 animate-fadeInUp"
          autoComplete="off"
        >
          {/* Party */}
          <div className="col-span-1">
            <label
              htmlFor="partyId"
              className="block mb-2 font-bold text-[color:var(--primary)] text-lg flex items-center gap-2 hover:text-[color:var(--secondary)] transition"
            >
              <span role="img" aria-label="party">👤</span> Party Name
            </label>
            <div className="relative">
              <select
                name="partyId"
                id="partyId"
                value={sellStockForm.partyId}
                onChange={handleFormChange}
                className="w-full border-2 border-[color:var(--primary)] bg-[#f8fbf9] rounded-xl px-5 py-3 text-[color:var(--primary)] focus:ring-2 focus:ring-[color:var(--primary)]/60 font-semibold transition-all"
                required
                style={{ color: 'var(--primary)' }}
              >
                <option value="">Choose Party</option>
                {partiesList.map((p) => (
                  <option key={String(p.id)} value={String(p.id)}>
                    {p.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Category */}
          <div className="col-span-1">
            <label
              htmlFor="category"
              className="block mb-2 font-bold text-[color:var(--secondary)] text-lg flex items-center gap-2 hover:text-[color:var(--primary)] transition"
            >
              <span role="img" aria-label="category">📂</span> Category
            </label>
            <div className="relative">
              <select
                name="category"
                id="category"
                value={sellStockForm.category}
                onChange={handleFormChange}
                required
                disabled={!sellStockForm.partyId}
                className={`w-full border-2 bg-[#fffcf7] border-[color:var(--secondary)] rounded-xl px-5 py-3 text-[color:var(--secondary)] font-semibold focus:ring-2 focus:ring-[color:var(--secondary)]/50 transition-all ${
                  !sellStockForm.partyId ? 'bg-gray-50 opacity-60 cursor-not-allowed' : ''
                }`}
                style={{ color: 'var(--secondary)' }}
              >
                <option value="">Select Category</option>
                {partyCategories.map((cat) => (
                  <option key={String(cat)} value={cat}>
                    {cat}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Stock Name — now shows deduplicated list */}
          <div className="col-span-1 md:col-span-2">
            <label
              htmlFor="stockId"
              className="block mb-2 font-bold text-[color:var(--primary)] text-lg flex items-center gap-2 hover:text-[color:var(--secondary)] transition"
            >
              <span role="img" aria-label="stock">🏷️</span> Stock Name
            </label>
            <div className="relative">
              <select
                name="stockId"
                id="stockId"
                value={sellStockForm.stockId}
                onChange={handleFormChange}
                required
                disabled={!sellStockForm.category}
                className={`w-full border-2 border-[color:var(--primary)] bg-[#f6fbf8] rounded-xl px-5 py-3 text-[color:var(--primary)] font-semibold focus:ring-2 focus:ring-[color:var(--primary)]/50 transition-all ${
                  !sellStockForm.category ? 'bg-gray-50 opacity-60 cursor-not-allowed' : ''
                }`}
                style={{ color: 'var(--primary)' }}
              >
                <option value="">Select Stock</option>
                {stocksInCurrentCategory.map((stock) => (
                  <option key={`${stock.category}__${stock.stock_name}`} value={stock.stock_name}>
                    {stock.stock_name}
                  </option>
                ))}
              </select>
            </div>
            {sellStockForm.category && stocksInCurrentCategory.length === 0 && (
              <p className="text-xs text-center text-red-500 mt-2 font-mono italic">
                No stocks available under this category.
              </p>
            )}
          </div>

          {/* Units To Sell */}
          <div className="col-span-1">
            <label
              htmlFor="sellUnits"
              className="block mb-2 font-bold text-[color:var(--primary)] text-lg flex items-center gap-2 hover:text-[color:var(--secondary)] transition"
            >
              <span role="img" aria-label="units">🔢</span> Units To Sell
              {selectedStockObj && (
                <span className="text-xs ml-2 text-gray-400 font-normal">
                  (Available:{' '}
                  <b className="text-[color:var(--secondary)]">{selectedStockObj.unit}</b>)
                </span>
              )}
            </label>
            <div className="relative">
              <input
                type="number"
                name="sellUnits"
                id="sellUnits"
                value={sellStockForm.sellUnits}
                required
                disabled={!sellStockForm.stockId}
                min={0}
                max={selectedStockObj ? selectedStockObj.unit : undefined}
                onChange={handleFormChange}
                className="w-full border-2 border-[color:var(--primary)] bg-[#f6fbf8] rounded-xl px-5 py-3 text-[color:var(--primary)] font-medium focus:ring-2 focus:ring-[color:var(--primary)]/40 placeholder-gray-300 transition-all"
                placeholder="How many units to sell"
                style={{ color: 'var(--primary)' }}
                step="any"
                inputMode="decimal"
                pattern="[0-9.]*"
              />
            </div>
            {sellStockForm.sellUnits &&
            selectedStockObj &&
            parseFloat(sellStockForm.sellUnits) > parseFloat(selectedStockObj.unit) ? (
              <span className="text-xs text-red-600 font-semibold px-2 py-1 inline-block bg-[#ffedf1] rounded mt-1">
                Not enough units available!
              </span>
            ) : null}
          </div>

          {/* Sell Amount */}
          <div className="col-span-1">
            <label
              htmlFor="sellAmount"
              className="block mb-2 font-bold text-[color:var(--secondary)] text-lg flex items-center gap-2 hover:text-[color:var(--primary)] transition"
            >
              <span role="img" aria-label="amount">💰</span> Sell Amount
              <span className="text-xs bg-[#fff8ef] text-[color:var(--primary)] px-2 py-1 rounded font-mono ml-2">
                (Auto: {(autoAmount || 0).toFixed(2)}{' '}
                {sellStockForm.sellUnits ? 'calculated' : ''})
              </span>
            </label>
            <div className="relative">
              <input
                type="number"
                name="sellAmount"
                id="sellAmount"
                placeholder={`Auto: ${(autoAmount || 0).toFixed(2)}`}
                value={sellStockForm.sellAmount}
                min={0}
                step="any"
                onChange={handleFormChange}
                required
                disabled={!sellStockForm.stockId}
                className="w-full border-2 border-[color:var(--secondary)] bg-[#fff8ef] rounded-xl px-5 py-3 text-[color:var(--secondary)] font-medium focus:ring-2 focus:ring-[color:var(--secondary)]/50 transition-all placeholder-gray-400"
                style={{ color: 'var(--secondary)' }}
                inputMode="decimal"
                pattern="[0-9]*"
              />
            </div>
            <span className="block text-xs text-gray-400 mt-1 font-mono ml-2">
              Leave blank for auto-calculated. You can adjust if desired.
            </span>
          </div>

          {/* Indirect Charges */}
          <div className="col-span-1">
            <label
              htmlFor="indirectCharges"
              className="block mb-2 font-bold text-[color:var(--primary)] text-lg flex items-center gap-2 hover:text-[color:var(--secondary)] transition"
            >
              <span role="img" aria-label="fees">💸</span> Indirect Charges
            </label>
            <div className="relative">
              <input
                type="number"
                name="indirectCharges"
                id="indirectCharges"
                placeholder="Enter indirect charges (if any)"
                value={sellStockForm.indirectCharges}
                min={0}
                step="any"
                onChange={handleFormChange}
                disabled={!sellStockForm.stockId}
                className="w-full border-2 border-[color:var(--primary)] bg-[#f6fbf8] rounded-xl px-5 py-3 text-[color:var(--primary)] font-normal focus:ring-2 focus:ring-[color:var(--primary)]/60 placeholder-gray-300 transition-all"
                style={{ color: 'var(--primary)' }}
              />
            </div>
          </div>

          {/* Date */}
          <div className="col-span-1">
            <label
              htmlFor="date"
              className="block mb-2 font-bold text-[color:var(--secondary)] text-lg flex items-center gap-2 hover:text-[color:var(--primary)] transition"
            >
              <span role="img" aria-label="date">📅</span> Date
            </label>
            <div className="relative">
              <input
                type="date"
                name="date"
                id="date"
                value={sellStockForm.date}
                onChange={handleFormChange}
                required
                className="w-full border-2 border-[color:var(--secondary)] bg-[#fff8ef] rounded-xl px-5 py-3 text-[color:var(--secondary)] font-medium focus:ring-2 focus:ring-[color:var(--secondary)]/40 transition-all"
                disabled={!sellStockForm.stockId}
                style={{ color: 'var(--secondary)' }}
              />
            </div>
          </div>

          {/* Submit */}
          <div className="col-span-1 md:col-span-2 flex flex-col md:flex-row-reverse justify-between items-center gap-3 pt-2">
            <button
              type="submit"
              disabled={loading}
              className="px-10 py-3 rounded-full bg-gradient-to-r from-[color:var(--primary)] to-[color:var(--secondary)] text-white font-extrabold text-2xl transform hover:scale-105 active:scale-100 transition-all focus:outline-none focus:ring-4 focus:ring-[color:var(--primary)]/50 disabled:opacity-60 flex items-center gap-2 border-b-4 border-[color:var(--secondary)]/50"
              style={{
                boxShadow: '0 8px 48px 3px #94efd990, 0 3px 15px -2px #f8bb498f',
              }}
            >
              {loading ? (
                <>
                  <svg
                    className="animate-spin mr-2 h-6 w-6 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v8z"
                    />
                  </svg>
                  Selling...
                </>
              ) : (
                <>
                  <span role="img" aria-label="sell">💸</span> Sell Stock
                </>
              )}
            </button>
          </div>
        </form>
      </div>
      <style>{`
        :root {
          --primary: ${PRIMARY};
          --secondary: ${SECONDARY};
        }
        .duo-gradient-text {
          background: linear-gradient(90deg, var(--primary), var(--secondary) 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        @media (max-width: 600px){
          .duo-form-glow:before, .duo-form-glow:after{display:none;}
        }
        .animate-fadein{
          animation: fadeInLeft 0.7s cubic-bezier(.29,.31,.41,1.41);
        }
        @keyframes fadeInLeft{
          0%{ opacity:0; transform:translateX(-100%);}
          80%{ opacity:0.2;}
          100%{ opacity:1; transform: translateX(0);}
        }
        .animate-fadeInUp {
          animation: fadeInUp 1.0s cubic-bezier(.38,.33,.52,1.42);
        }
        @keyframes fadeInUp {
          0% {opacity: 0; transform: translateY(40px);}
          100% {opacity: 1; transform: translateY(0);}
        }
      `}</style>
    </div>
  );
};

export default SellStocksPage;